/* eslint-disable no-unused-vars, jsx-a11y/anchor-is-valid, jsx-a11y/alt-text, eqeqeq, react-hooks/exhaustive-deps */
// WeeklyCalendarEvent.jsx
import react, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import DOMPurify from "dompurify";
import { useHistory, useLocation } from "react-router-dom";
import { useTranslation } from 'react-i18next';

import WeeklyCalendarUI from "./WeeklyCalendarUI";
import {
    GetWeeklyCalendar_api, FetchZoneList_api, MakeBooking_api, CancelBooking_api, ReportParkingViolation_api,
    GetAlternateParkingSpot_api, CancelMeeting_api, DeclineMeeting_api, /* RescheduleMeeting_api (RON-5375: legacy flow commented out), */ CheckInUser_api,
    BookingStatus_api, PostBookingQuestion_api, PostBookingAnswer_api
} from "./WeeklyCalendarAPI";

import { Images } from "../Common/Images.jsx";
import NewMeetingModal from '../Common/NewMeetingModal';
//import UpdateMeetingModal from '../Common/UpdateMeetingModal';
import CustomSearchableDropdown from "../Common/CustomSearchableDropdown.jsx";
import SpotTags from "../Common/SpotTags.jsx";
import NotificationMessage from "../Common/NotificationMessage.jsx";
import PostbookingQueModal from "../Common/PostbookingQueModal.jsx";
import NoVehiclePopUp from "../Common/NoVehiclePopUp.jsx";

import { delay, formatDate, getWeekKey, getBookingDateStr, formatDateToEEEddMMM, getCurrentDateTime, formatDateYYYYMMDD, toSafeFloat, formatReactString, getDisplayRefundCreditValue, parseLocalDate }
    from "../../utils/CommonUtils.js";

import { meeting } from "@microsoft/teams-js";
import DatePicker from "react-datepicker";

import AlertPopupModal from "../Common/AlertPopupModal.jsx";
import ErrorPopupModal from "../Common/ErrorPopupModal.jsx";
import { useApiResponseHandler } from "../../hooks/useApiResponseHandler.js";
import { handleApiResponse } from "../../hooks/notificationHelper.js";
import { useApiUiResponse } from "../../hooks/apiUiResponseHelper.js";

function WeeklyCalendarEvent() {
    const { t } = useTranslation("common");
    const { i18n } = useTranslation();
    const locale = i18n.language.split("-")[0];

    const history = useHistory();
    const location = useLocation();
    const preselectedZoneId = location.state?.selectedZoneId;
    const [UserName, setUserName] = useState(localStorage.getItem("firstname") + " " + localStorage.getItem("lastname"));

    const [events, setEvents] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [selectedDay, setSelectedDay] = useState(null);

    const [zones, setZones] = useState([]);
    const [zoneDropdownOpen, setZoneDropdownOpen] = useState(false);
    const [selectedZoneId, setSelectedZoneId] = useState(null); // numeric zone id
    const [zoneMap, setZoneMap] = useState({}); // { [zoneId]: mapType }
    const [zoneName, setZoneName] = useState(null);

    const [recordsData, setRecordsData] = useState(null);

    const [vehicleId, setVehicleId] = useState("");
    const [selectedVehicle, setSelectedVehicle] = useState(null);

    const [currentDate, setCurrentDate] = useState(new Date()); // Represents today's date for logic
    const [weekData, setWeekData] = useState({}); // Stores fetched weekly booking schedules

    const [slotMinTime, setSlotMinTime] = useState("00:00:00");
    const [slotMaxTime, setSlotMaxTime] = useState("24:00:00");

    const [zoneCreditValue, setZoneCreditValue] = useState();
    const [individualDayCost, setIndividualDayCost] = useState(0);

    // Pre/ Post Event Modal
    //const [showEventModal, setShowEventModal] = useState(null);
    const [showPreEventModal, setShowPreEventModal] = useState(null);   // Before Booking
    const [showPostEventModal, setShowPostEventModal] = useState(null); // After Booking
    const [isExistingEvent, setisExistingEvent] = useState(false);
    const [selectedEvent, setSelectedEvent] = useState(null);

    const [isAllDayContext, setIsAllDayContext] = useState(false);
    const [showAlldayPreEventModal, setShowAlldayPreEventModal] = useState(null);       // Before Allday Booking
    const [showAlldayPostEventModal, setShowAlldayPostEventModal] = useState(null); // After Allday Booking    

    const [spotAvailable, setSpotAvailable] = useState(0);

    //handleShowBookingModal
    const [selectedBookingDate, setSelectedBookingDate] = useState(null);

    //ScheduleMeeting
    const [showMeetingModal, setShowMeetingModal] = useState(false);
    const [showScheduleMeetingModal, setShowScheduleMeetingModal] = useState(false);
    const [meetingModalDate, setMeetingModalDate] = useState(null);

    //Reschedule Meeting - RON-5375: legacy flow commented out, replaced by the edit-meeting flow below
    // const [showRescheduleMeetingModal, setShowRescheduleMeetingModal] = useState(false);
    // const [selectedRescheduleDate, setSelectedRescheduleDate] = useState("");
    // const [showReScheduleMeetingDateSelectModal, setShowReScheduleMeetingDateSelectModal] = useState(false);
    // const [rescheduledBookingOccurrence, setRescheduledBookingOccurrence] = useState(0);

    //Edit Meeting (RON-5375) - reuse NewMeetingModal in edit mode
    const [showEditMeetingModal, setShowEditMeetingModal] = useState(false);
    const [editRescheduleType, setEditRescheduleType] = useState(2); // 2 = this event, 1 = whole series, 3 = this and following

    //handle Cancel Meeting
    const [showCancelMeetingModal, setShowCancelMeetingModal] = useState(false);
    const [showCancelMeetingDateSelectModal, setShowCancelMeetingDateSelectModal] = useState(false);

    //handle Decline Meeting
    const [showDeclineMeetingModal, setShowDeclineMeetingModal] = useState(false);
    const [showDeclineMeetingDateSelectModal, setShowDeclineMeetingDateSelectModal] = useState(false);

    //handle Cancel Booking
    const [cancelBookingSpotId, setCancelBookingSpotId] = useState(null);
    const [showCancelConfirm, setShowCancelConfirm] = useState(false);

    //handle SpotTakenConfirmation
    const [showReportParkingViolationModal, setShowReportParkingViolationModal] = useState(false);
    const [showAlternateParkingSpotModal, setShowAlternateParkingSpotModal] = useState(false);
    const [parkingViolationReportingData, setParkingViolationReportingData] = useState(false);

    //handle Update Meeting Modal
    const [showUpdateModal, setShowUpdateModal] = useState(false);
    const [updateMeetingData, setUpdateMeetingData] = useState(null);

    //handle Postbooking Que Modal
    const [showPostbookingQueModal, setShowPostbookingQueModal] = useState(false);
    const [postbookingQueModalData, setPostbookingQueModalData] = useState([]);
    const [postRequestParams, setPostRequestParams] = useState(null);

    const [open, setOpen] = useState(true);

    const [mapAvailable, setMapAvailable] = useState(null);
    const [mapAvailableType, setMapAvailableType] = useState(null);
    const [zoneType, setZoneType] = useState();
    const [isQueue, setIsQueue] = useState(0);
    const [preBookingQuestion, setPreBookingQuestion] = useState(null)
    const [checkedPreBookingQue, setCheckedPreBookingQue] = useState(false);
    const [holidays, setHolidays] = useState([]);
    const [spotTagList, setSpotTagList] = useState([]);
    const [deskAvailable, setDeskAvailable] = useState();
    const [isBookingBlocked, setIsBookingBlocked] = useState(0);

    const [displayQueue, setDisplayQueue] = useState(0);
    const displayQueueRef = useRef(displayQueue);

    const [meetingRoomAvailable, setMeetingRoomAvailable] = useState();
    const [hourlySpotAvailable, setHourlySpotAvailable] = useState();
    const [checkInFlag, setCheckInFlag] = useState(0);
    const [checkInType, setCheckInType] = useState([]);
    const [spotId, setSpotId] = useState(null);
    const [repeatOption, setRepeatOption] = useState("0");
    const [spotType, setSpotType] = useState(null);
    const [bookingPeriod, setBookingPeriod] = useState(0);
    const [eventStartTime, setEventStartTime] = useState("");
    const [eventEndTime, setEventEndTime] = useState("");
    const [meetingId, setMeetingId] = useState(0);
    const [meetingName, setMeetingName] = useState("");
    const [organiserName, setOrganiserName] = useState("");
    const [joinedQueue, setJoinedQueue] = useState(0);
    const [showReportLabel, setShowReportLabel] = useState(0);
    const [queuePosition, setQueuePosition] = useState(0);
    const [showWaitlistPosition, setShowWaitlistPosition] = useState(0);
    const [employeeQueueCount, setEmployeeQueueCount] = useState(0);

    const [spotName, setSpotName] = useState("");
    const [organiserId, setOrganiserId] = useState(0);
    const [userId, setUserId] = useState(0);
    const [isApproversExist, setIsApproversExist] = useState(0);
    const [meetingApproveStatus, setMeetingApproveStatus] = useState(0);
    const [isApprover, setIsApprover] = useState(0);
    const [totalBookings, setTotalBookings] = useState(0);
    const [isSpaceNotAvailable, setIsSpaceNotAvailable] = useState(false);

    const [loadingDates, setLoadingDates] = useState([]); // Dates currently loading bookings

    const [clickedFullDay, setClickedFullDay] = useState(null); //This matches your modal usage (clickedFullDay is already referenced everywhere).

    const [showModal, setShowModal] = useState(false);
    const [showAddVehiclePopup, setShowAddVehiclePopup] = useState(false);
    const [weekStartDate, setWeekStartDate] = useState(null);

    const lastWeekStartRef = useRef(null);

    const {
        handleResponseCode,
        showAlertPopupModal,
        alertPopupModalData,
        showErrorPopupModal,
        errorPopupModalData,
        setShowAlertPopupModal,
        setShowErrorPopupModal
    } = useApiResponseHandler();

    const isHolidayInList = (date) => {
        const holidays = recordsData?.HolidaysZoneWise || [];
        return holidays.includes(formatDateYYYYMMDD(date));
        ////console.log("holidays from isHolidayInList")
    };

    const handleDatesSet = useCallback((info) => {
        if (lastWeekStartRef.current === info.startStr) return;

        lastWeekStartRef.current = info.startStr;

        const weekStart = new Date(info.start);

        setWeekStartDate(weekStart);

    }, []);


    const [notification, setNotification] = useState(null);
    const { handleApiUiResponse, renderApiUi } = useApiUiResponse(t);

    const getVisibleWeekStartDateString = (fallbackDate) => {
        if (typeof lastWeekStartRef.current === "string" && lastWeekStartRef.current) {
            return lastWeekStartRef.current;
        }

        if (weekStartDate instanceof Date && !Number.isNaN(weekStartDate.getTime())) {
            return weekStartDate.toLocaleDateString("en-CA");
        }

        if (typeof fallbackDate === "string") {
            return fallbackDate;
        }

        return formatDate(fallbackDate);
    };

    // RON-5375: occurrence date of a clicked event, as a LOCAL Date (no UTC shift),
    // matching the dateStr logic used in handleEventClick.
    const getEventBookingDate = (event) => {
        if (!event) return null;

        if (event.start instanceof Date && !Number.isNaN(event.start.getTime())) {
            return event.start;
        }

        const dateOnly = typeof event.startStr === "string" ? event.startStr.slice(0, 10) : "";
        if (!dateOnly) return null;

        const [year, month, day] = dateOnly.split("-").map(Number);
        return new Date(year, month - 1, day);
    };

    const handleAddVehiclePopupClose = () => {
        setShowAddVehiclePopup(false);
    };

    const handleAddVehiclePopupConfirm = () => {
        setShowAddVehiclePopup(false);
    };

    const shouldShowNoVehiclePopup = (scheduleForDate) => {
        const isPrimaryVehicleAbsent = recordsData?.Redirect === "AddPrimaryVehicle";
        const employeeVehicleTypes = scheduleForDate?.EmployeeVehicleType || [];

        return Number(zoneType) === 1 && employeeVehicleTypes.length === 0 && isPrimaryVehicleAbsent;
    };

    const fetchPreEventModalData = async (dateStr) => {

        setPreBookingQuestion(recordsData?.PreBookingQuestion ? recordsData.PreBookingQuestion.replace(/<\/?p>/g, "").trim() : "");

        const schedule = recordsData?.Schedule?.find((d) => d.BookingDate === dateStr);
        if (!schedule) return;

        setDeskAvailable(schedule?.DeskAvailable);
        setIsBookingBlocked(schedule?.IsBookingBlocked || 0);
        setDisplayQueue(schedule?.DisplayQueue);
        setMeetingRoomAvailable(schedule?.MeetingRoomAvailable);
        setHourlySpotAvailable(schedule?.HourlySpotAvailable);
        setIndividualDayCost(schedule?.IndividualDayCost);
        setJoinedQueue(schedule?.JoinedQueue);
        setQueuePosition(schedule?.QueuePosition);
        setEmployeeQueueCount(schedule?.EmployeeQueueCount);
        setTotalBookings(schedule?.Bookings.length);
        setSpotAvailable(schedule?.SpotAvailable);
        setClickedFullDay(dateStr);
        setSelectedBookingDate(new Date(dateStr));
    };

    const fetchPostEventData = async (event) => {
        ////console.log("event of fetchPostEventData- ", event);
        if (!event) return;

        const dateStr = event.allDay
            ? event.startStr
            : event.start?.toLocaleDateString("en-CA");
        //: event.start.toISOString().split("T")[0];
        //console.log("dateStr of fetchPostEventData- ", dateStr);
        setPreBookingQuestion(recordsData?.PreBookingQuestion ? recordsData.PreBookingQuestion.replace(/<\/?p>/g, "").trim() : "");
        const schedule = recordsData?.Schedule?.find((d) => d.BookingDate === dateStr);
        if (!schedule) return;

        setDeskAvailable(schedule?.DeskAvailable);
        setIsBookingBlocked(schedule?.IsBookingBlocked || 0);
        setDisplayQueue(schedule?.DisplayQueue);
        setMeetingRoomAvailable(schedule?.MeetingRoomAvailable);
        setHourlySpotAvailable(schedule?.HourlySpotAvailable);
        setIndividualDayCost(schedule?.IndividualDayCost);
        setJoinedQueue(schedule?.JoinedQueue);
        setQueuePosition(schedule?.QueuePosition);
        setEmployeeQueueCount(schedule?.EmployeeQueueCount);
        setTotalBookings(schedule?.Bookings.length);

        setZoneCreditValue(parseFloat(recordsData?.ZoneCreditValue));
        ////console.log("event.extendedProps of fetchPostEventData-", event.extendedProps)
        // ✅ EXISTING BOOKING EVENT
        const {
            SpotTagList,
            SpotId,
            SpotType,
            CheckInFlag,
            CheckInType,
            BookingPeriod,
            RepeatOption,
            StartTime,
            EndTime,
            MeetingName,
            OrganiserName,
            ShowReportLabel,
            SpotName,
            OrganiserId,
            UserId,
            IsApproversExist,
            MeetingApproveStatus,
            IsApprover,
            ShowLeaveQueue,
            QueuePosition,
            EmployeeQueueCount,

        } = event.extendedProps;

        // 🔥 SET FROM EXTENDED PROPS ONLY
        setSpotTagList(SpotTagList);
        setSpotId(SpotId);
        setSpotType(SpotType);
        setCheckInFlag(CheckInFlag);
        setCheckInType(CheckInType || []);
        setBookingPeriod(BookingPeriod);
        setRepeatOption(RepeatOption);
        setEventStartTime(StartTime || "");
        setEventEndTime(EndTime || "");
        setMeetingName(MeetingName);
        setOrganiserName(OrganiserName);
        setShowReportLabel(ShowReportLabel);
        setSpotName(SpotName);
        setOrganiserId(OrganiserId);
        setUserId(UserId);
        setIsApproversExist(IsApproversExist);
        setMeetingApproveStatus(MeetingApproveStatus);
        setIsApprover(IsApprover);
        setQueuePosition(QueuePosition);
        setEmployeeQueueCount(EmployeeQueueCount);
        setClickedFullDay(event.startStr);
        setSelectedBookingDate(new Date(event.start));
        ////console.log("fetchPostEventData -- DisplayQueue === 1 &&  JoinedQueue === 0 && totalBookings === 0, QueuePosition----", displayQueue, joinedQueue, totalBookings, queuePosition)
    };

    const handleSlotAction = async ({ dateStr, isAllDay }) => {

        if (!selectedZoneId) return;
        //handleBlockSlot(dateStr);
        console.log("dateStr and isAllDay of handleSlotAction-", dateStr, isAllDay);
        await fetchPreEventModalData(dateStr);

        if (isAllDay) {
            const scheduleForDate = recordsData?.Schedule?.find((d) => d.BookingDate === dateStr);
            const hasExistingBookings = (scheduleForDate?.Bookings?.length || 0) > 0;
            console.log("scheduleForDate and hasExistingBookings--", scheduleForDate, hasExistingBookings);
            if (hasExistingBookings) {
                const existingAllDayEvent =
                    ["LEAVE_QUEUE", "BOOKING", "JOIN_QUEUE"]
                        .map((targetEventType) => events.find((eventItem) => {
                            const eventDate =
                                typeof eventItem.start === "string"
                                    ? eventItem.start.split("T")[0]
                                    : eventItem.start?.toLocaleDateString("en-CA");

                            return (
                                eventDate === dateStr &&
                                (eventItem.allDay === true || eventItem.extendedProps?.isFullDayFallback === true) &&
                                eventItem.extendedProps?.eventType === targetEventType
                            );
                        }))
                        .find(Boolean);

                if (existingAllDayEvent) {
                    await handleEventClick({
                        eventInfo: {
                            ...existingAllDayEvent,
                            startStr:
                                existingAllDayEvent.startStr ||
                                (typeof existingAllDayEvent.start === "string"
                                    ? existingAllDayEvent.start
                                    : dateStr),
                        },
                    });
                    return;
                }
            }

            if (shouldShowNoVehiclePopup(scheduleForDate)) {
                setShowPreEventModal(false);
                setShowPostEventModal(false);
                setShowAlldayPostEventModal(false);
                setShowAlldayPreEventModal(false);
                setShowAddVehiclePopup(true);
                return;
            }

            console.log("EMPTY ALL-DAY slot clicked");
            // 🟢 EMPTY ALL-DAY → PRE
            setIsAllDayContext(true);
            setShowPostEventModal(false);
            setShowAlldayPostEventModal(false);
            setShowPreEventModal(false);
            setShowAlldayPreEventModal(true);
            return;
        }

        // 🔵 EMPTY TIME-GRID → PRE
        const scheduleForDate = recordsData?.Schedule?.find((d) => d.BookingDate === dateStr);

        if (shouldShowNoVehiclePopup(scheduleForDate)) {
            setIsAllDayContext(false);
            setShowAlldayPreEventModal(false);
            setShowAlldayPostEventModal(false);
            setShowPostEventModal(false);
            setShowPreEventModal(false);
            setShowAddVehiclePopup(true);
            return;
        }

        setIsAllDayContext(false);
        setShowAlldayPreEventModal(false);
        setShowAlldayPostEventModal(false);
        setShowPostEventModal(false);
        if (mapAvailable === 1) {
            setShowPreEventModal(true);
        }
    };
    const handleEventClick = async ({ eventInfo }) => {
        console.log("clickInfo of handleEventClick-", eventInfo);

        const event = eventInfo;
        const eventType = event.extendedProps?.eventType;
        const isAllDayBooking =
            event.allDay === true || event.isFullDayFallback === true;

        const dateStr = event.allDay
            ? event.startStr
            : event.start?.toLocaleDateString("en-CA");

        if (!dateStr) return;

        setSelectedEvent(event);

        // 🔒 EVENT CLICK = POST POPUPS ONLY
        if (isAllDayBooking) {
            console.log("ALL-DAY slot clicked with event ,eventType- ", event, eventType);
            setIsAllDayContext(true);

            setShowPreEventModal(false);
            setShowPostEventModal(false);
            setShowAlldayPreEventModal(false);

            if (eventType === "JOIN_QUEUE") {
                // 🟠 ALL-DAY POST (Queue context)
                await fetchPostEventData(event);
                setShowAlldayPreEventModal(true);
                return;
            }

            // 🟠 ALL-DAY POST (Normal booking)
            await fetchPostEventData(event);
            setShowAlldayPostEventModal(true);
            console.log("isAllDayBooking -- event click, showAlldayPostEventModal--", event, showAlldayPostEventModal);
            return;
        }

        // 🔵 TIME-GRID POST
        setIsAllDayContext(false);

        setShowAlldayPreEventModal(false);
        setShowAlldayPostEventModal(false);
        setShowPreEventModal(false);

        await fetchPostEventData(event);
        setShowPostEventModal(true);
    };

    const handleBlockSlot = ({ dateStr }) => {
        const schedule = recordsData?.Schedule?.find((d) => d.BookingDate === dateStr);
        const holidays = recordsData?.HolidaysZoneWise || [];
        // Block if holiday
        if (holidays.includes(dateStr)
            //|| isNoSpace
        ) {
            ////console.log("Holiday clicked — modal blocked:", dateStr);
            return;
        }
    };

    const fetchZones = async () => {
        try {
            if (isLoading) return;
            setIsLoading(true);
            const response = await FetchZoneList_api({});
            console.log("FetchZoneList_api() - response -- ", response);
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });
            ////console.log("Zones fetched:", response);
            const zonesList = response?.Data?.Records?.ZoneList || [];
            ////console.log("zonesList fetched:", response?.Data?.Records?.ZoneList);
            setZones(zonesList);
            // build zoneId -> mapType lookup
            const map = {};
            zonesList.forEach((z) => {
                map[z.Id] = Number(z.MapType ?? z.Maptype ?? 2);
            });
            setZoneMap(map);

            const routeZone = zonesList.find(
                (zone) => String(zone.Id) === String(preselectedZoneId)
            );
            const defaultZone = zonesList.find((z) => z.DefaultId === 1);
            const initialZone = routeZone || defaultZone || zonesList[0];

            if (initialZone) {
                setSelectedZoneId(initialZone.Id);
            }
        } catch (error) {

            console.error("Zone List Fetch Error:", error);
        }
        setIsLoading(false);
    };

    useEffect(() => {
        document.title = `${t("react_weekly_calendar")} | Ronspot`
    }, []);

    useEffect(() => {
        fetchZones();
    }, []);

    useEffect(() => {
        if (!weekStartDate || !selectedZoneId) return;

        fetchBookings(
            selectedZoneId,
            weekStartDate.toLocaleDateString("en-CA")
        );

        const selectedZoneName =
            zones.find(z => String(z.Id) === String(selectedZoneId))?.ZoneName || "";

        setZoneName(selectedZoneName);
    }, [weekStartDate, selectedZoneId]);

    // 🔹 Fetch bookings from API
    const fetchBookings = async (zoneIdParam, bookingDateParam) => {
        setIsLoading(true);
        const zoneId = zoneIdParam;
        ////console.log("fetchBookings called with zoneId:", zoneId, "and bookingDateParam:", bookingDateParam);
        if (!bookingDateParam) return;

        const bookingDate =
            typeof bookingDateParam === "string"
                ? formatDate(bookingDateParam)
                : formatDate(bookingDateParam);

        try {
            const reqParams = {
                BookingStartDate: bookingDate,
                ZoneId: zoneId,
            };

            const response = await GetWeeklyCalendar_api(reqParams);
            const { ResponseCode, Records } = response.Data;
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 0,
                alertPopup: 1
            });

            setRecordsData(Records);

            if (ResponseCode !== 200 || !Array.isArray(Records?.Schedule)) {
                setEvents([]);
                return;
            }
            setSlotMinTime(Records?.SpotMinStartTime || "00:00:00");
            setSlotMaxTime(Records?.SpotMaxEndTime || "24:00:00");
            setMapAvailable(Records?.MapExist);
            setMapAvailableType(Records?.MapType);
            setIsQueue(Records?.QueueUser ?? 0);
            setZoneType(Records?.ZoneType);
            ////console.log("Records?.ZoneType-->",Records?.ZoneType);
            setZoneCreditValue(parseFloat(Records?.ZoneCreditValue));
            setPreBookingQuestion(Records?.PreBookingQuestion ? Records?.PreBookingQuestion.replace(/<\/?p>/g, "").trim() : "");
            ////console.log("Records?.PreBookingQuestion-", Records?.PreBookingQuestion);
            setShowWaitlistPosition(Records?.ShowWaitlistPosition);
            setWeekData(Records?.Schedule);
            const rcHolidays = Array.isArray(Records?.HolidaysZoneWise)
                ? Records?.HolidaysZoneWise
                : [];

            setHolidays(rcHolidays);
            ////console.log("rcHolidays, holidays in fetchBookings-->", holidays);
            const schedule = Records?.Schedule?.find((d) => d.BookingDate === bookingDate);
            setQueuePosition(schedule?.QueuePosition);
            setEmployeeQueueCount(schedule?.EmployeeQueueCount);
            setIsSpaceNotAvailable(schedule?.DeskAvailable == 0 || schedule?.MeetingRoomAvailable == 0 || schedule?.HourlySpotAvailable == 0);
            //setJoinedQueue(schedule?.[0]?.JoinedQueue);
            ////console.log("zoneType, schedule?.[0]?.JoinedQueue-",zoneType, schedule?.[0]?.JoinedQueue);


            // ✅ FLATTEN ALL BOOKINGS (single + multi-slot safe)
            const zoneType = Records.ZoneType;
            const formattedEvents = Records.Schedule.flatMap((day) =>
                (day.Bookings || []).map((b, index) => {
                    const isAllDay =
                        !b.StartTime ||
                        !b.EndTime ||
                        b.StartTime === "00:00" ||
                        b.EndTime === "23:59";

                    const startTime = isAllDay ? "" : b.StartTime;
                    const endTime = isAllDay ? "" : b.EndTime;

                    const eventId =
                        b.MeetingId && b.MeetingId > 0
                            ? `MEET-${b.MeetingId}-${day.BookingDate}-${index}`
                            : `FD-${b.SpotId}-${day.BookingDate}-${index}`;

                    const isLeaveQueueBooking = (day, b) =>
                        day.JoinedQueue === 1 &&
                        (
                            (zoneType === 1 && b.SpotType === 1) ||
                            (zoneType === 2 && b.SpotType === 2)
                        ) &&
                        b.BookingPeriod === 1;

                    if (isLeaveQueueBooking(day, b, zoneType)) {
                        return [];          // this is condition is omit the leave queue booking in main booking array
                    }
                    return {
                        id: eventId,

                        title: b.MeetingName
                            ? `${b.MeetingName} - ${b.SpotName}`
                            : b.SpotName,
                        ...(isAllDay
                            ? {
                                start: day.BookingDate, // YYYY-MM-DD ONLY
                                allDay: true,
                            }
                            : {
                                start: `${day.BookingDate}T${startTime}:00`,
                                end: `${day.BookingDate}T${endTime}:00`,
                                allDay: false,
                            }),
                        /* start: `${day.BookingDate}T${startTime}`,
                        end: `${day.BookingDate}T${endTime}`, */

                        editable: false,
                        overlap: false,

                        extendedProps: {

                            eventType: "BOOKING",
                            startDate: b.StartDate,
                            StartTime: startTime,
                            EndTime: endTime,
                            timeIntervals: b.TimeIntervals,
                            spotTagList: b.SpotTagList,
                            spotId: b.SpotId,
                            spotType: b.SpotType,
                            spotName: b.SpotName,
                            checkInType: b.CheckInType,
                            checkInFlag: b.CheckInFlag,
                            organiserId: b.OrganiserId,
                            organiserName: b.OrganiserName,
                            meetingId: b.MeetingId,
                            meetingName: b.MeetingName,
                            userId: b.UserId,
                            meetingRepeat: b.MeetingRepeat,
                            showApproverDate: b.ShowApproverDate,
                            repeatOption: b.RepeatOption,
                            repeatOptionDay: b.RepeatOptionDay,
                            lastDateOfBookingAvailable: b.LastDateOfBookingAvailable,
                            selectedDays: b.SelectedDays,
                            bookingPeriod: b.BookingPeriod,
                            showReportLabel: b.ShowReportLabel,
                            isApproversExist: b.IsApproversExist,
                            meetingApproveStatus: b.MeetingApproveStatus,
                            isApprover: b.IsApprover,
                            zoneCurrentDateTime: Records.ZoneCurrentDateTime,
                            fullRefundCredit: day.FullRefundCredit,
                            halfRefundCredit: day.HalfRefundCredit,
                            noRefundCredit: day.NoRefundCredit,
                            refundStartDateTime: day.RefundStartDateTime,
                            refundEndDateTime: day.RefundEndDateTime,
                            isFullDayFallback: isAllDay,
                            //displayQueue: b.DisplayQueue,
                            //showLeaveQueue: showLeaveQueue,
                            //isFullDayFallback: !b.StartTime || !b.EndTime,
                        },
                    };
                })
            );

            const joinQueueEvents = Records.Schedule
                .filter(
                    (day) =>
                        day.DisplayQueue === 1 &&
                        day.JoinedQueue === 0 //&&
                    //day.Bookings.length === 0
                )
                .map((day) => ({
                    id: `JOIN-QUEUE-${day.BookingDate}`,
                    title: "Join Queue",
                    start: day.BookingDate,
                    allDay: true,

                    editable: false,
                    overlap: false,

                    // ✅ APPLY CLASS HERE
                    className: "fc-queue-event",

                    extendedProps: {
                        eventType: "JOIN_QUEUE",
                        joinedQueue: 0,
                        displayQueue: 1,
                    },
                }));

            //((zoneType === 1 && spotType === 1) || (zoneType === 2 && spotType === 2))           && (bookingPeriod === 1 && joinedQueue === 1)


            const leaveQueueEvents = Records.Schedule.flatMap((day) => {
                // 🚫 Not in queue → no event
                if (day.JoinedQueue !== 1) return [];

                // 🎯 Find ONE eligible booking (for props)
                const booking = (day.Bookings || []).find((b) => {
                    return (
                        ((zoneType === 1 && b.SpotType === 1) ||
                            (zoneType === 2 && b.SpotType === 2)) &&
                        b.BookingPeriod === 1
                    );
                });

                if (!booking) return [];

                return [
                    {
                        id: `LEAVE-QUEUE-${day.BookingDate}-${booking.SpotId}`,
                        title: "Leave Queue",
                        start: day.BookingDate,
                        allDay: true,
                        employeeQueueCount: day.EmployeeQueueCount,
                        editable: false,
                        overlap: false,
                        className: "fc-queue-event",

                        extendedProps: {
                            eventType: "LEAVE_QUEUE",
                            queuePosition: day.QueuePosition,
                            showLeaveQueue: true,
                            joinedQueue: 1,

                            // 🔁 keep same shape as BOOKING
                            spotTagList: booking.SpotTagList,
                            spotId: booking.SpotId,
                            spotType: booking.SpotType,
                            spotName: booking.SpotName,
                            checkInType: booking.CheckInType,
                            checkInFlag: booking.CheckInFlag,
                            organiserId: booking.OrganiserId,
                            organiserName: booking.OrganiserName,
                            meetingId: booking.MeetingId,
                            meetingName: booking.MeetingName,
                            userId: booking.UserId,
                            repeatOption: booking.RepeatOption,
                            bookingPeriod: booking.BookingPeriod,
                            showReportLabel: booking.ShowReportLabel,
                            isApproversExist: booking.IsApproversExist,
                            meetingApproveStatus: booking.MeetingApproveStatus,
                            isApprover: booking.IsApprover,
                            zoneCurrentDateTime: Records.ZoneCurrentDateTime,
                            fullRefundCredit: day.FullRefundCredit,
                            halfRefundCredit: day.HalfRefundCredit,
                            noRefundCredit: day.NoRefundCredit,
                            refundStartDateTime: day.RefundStartDateTime,
                            refundEndDateTime: day.RefundEndDateTime,
                            isFullDayFallback: true,
                        },
                    },
                ];
            });

            const allEvents = [
                ...formattedEvents,     //bookings/ meetings
                ...joinQueueEvents,        //joined queue 
                ...leaveQueueEvents];    //leave queue
            setEvents(allEvents);
            //console.log("allEvents [formattedEvents + queueEvents]Events:", allEvents);
            //setEvents(formattedEvents);
        } catch (error) {
            console.error("Error at fetchBookings:", error);
        }
        finally {
            setIsLoading(false);
        }
    };

    const refreshBookingsForRequestedDate = async (zoneId, bookingDateStr) => {
        const normalizedBookingDate =
            typeof bookingDateStr === "string" ? bookingDateStr : formatDate(bookingDateStr);

        if (!zoneId || !normalizedBookingDate) return;

        await fetchBookings(zoneId, getVisibleWeekStartDateString(normalizedBookingDate));
    };

    const ScheduleMeeting = (zoneId, bookingDateStr) => {
        const dateObj = new Date(bookingDateStr);

        ////console.log("Final date being passed:", dateObj);

        setMeetingModalDate(dateObj);      // ✅ set FIRST
        setShowPreEventModal(false);
        setShowMeetingModal(false);
        setShowScheduleMeetingModal(true); // ✅ open AFTER date is ready
    };

    // RON-5375: after a successful meeting edit, close the modal and refresh the visible week once.
    const handleEditMeetingRefresh = () => {
        setShowEditMeetingModal(false);
        fetchBookings(
            selectedZoneId,
            getVisibleWeekStartDateString(selectedBookingDate || selectedDate)
        );
    };

    // This is Confirm for New Meeting Creation
    const handleConfirm = (newMeetingData) => {
        ////console.log("✅ Meeting created successfully:", newMeetingData);

        // 👉 Optional: refresh your calendar or meeting list here
        fetchBookings(selectedZoneId, getVisibleWeekStartDateString(selectedDate)); // for example, re-fetch API data

        // Close the modal (in case it's still open)
        setShowScheduleMeetingModal(false);
    };
    // Rest of your utility functions and modal components...
    const formattedDate = currentDate.toLocaleDateString('en-US', {
        day: 'numeric',
        month: 'short',
    });

    const formattedOnlyDate = currentDate.toLocaleDateString('en-US', {
        day: 'numeric',
    });

    const formattedOnlyMonth = currentDate.toLocaleDateString('en-US', {
        month: 'long',
    });
    const formattedOnlyMonthShort = currentDate.toLocaleDateString('en-US', {
        month: 'short',
    });

    const formattedOnlyYear = currentDate.toLocaleDateString('en-US', {
        year: 'numeric'
    });

    const CheckInButton = ({ checkInFlag, zoneId, CheckInDate, spotId, bookingDateStr }) => (
        <div className="d-flex justify-content-between align-items-center gap-3">
            <div className="d-block w-100">
                <a
                    onClick={(e) => {
                        if (isLoading) return;
                        e.preventDefault();
                        if (!isLoading) {
                            setShowPostEventModal(false);
                            setShowAlldayPostEventModal(false);
                            checkIncheckOut(checkInFlag, zoneId, CheckInDate, spotId, bookingDateStr)
                        }
                    }}
                    className="fc-checkInBtn-button w-100 fc-checkInBtn-img">
                    <img src={Images.CheckInIcon} className="img-fluid"></img>
                    <span>{t("react_check_in")}</span>
                </a>
            </div>
        </div>
    );
    const CheckOutButton = ({ checkInFlag, zoneId, CheckInDate, spotId, bookingDateStr }) => (
        <div >
            <div className="d-block w-100">
                <a
                    onClick={(e) => {
                        if (isLoading) return;
                        e.preventDefault();
                        if (!isLoading) {
                            setShowPostEventModal(false);
                            setShowAlldayPostEventModal(false);
                            checkIncheckOut(checkInFlag, zoneId, CheckInDate, spotId, bookingDateStr);
                        }
                    }}
                    className="fc-checkInBtn-button fc-button fc-button-primary active w-100 fc-checkInBtn-img"
                >
                    <img src={Images.CheckInIcon} className="img-fluid"></img>
                    <span>{t("react_check_out")}</span>
                </a>
            </div>
        </div>
    );
    const LeaveQueButton = ({ zoneId, bookingDateStr, spotId }) => (
        <div >
            <div>
                <a
                    onClick={async (e) => {
                        e.preventDefault();
                        if (!isLoading) {
                            setShowAlldayPostEventModal(false);
                            await CancelBooking(
                                zoneId,
                                bookingDateStr,
                                spotId
                            );
                        }
                    }}
                    className="green-outline-with-icon w-100 mw-100 min-height-56"
                ><img src={Images.UserInQue} className="img-fluid"></img>
                    <span>{t("react_leave_waitlist")}</span>
                </a>
            </div>
        </div >
    );
    const DeclineButton = ({ isLoading }) => (
        <div >
            <div>
                <a
                    href="#"
                    onClick={async (e) => {
                        e.preventDefault();
                        if (!isLoading) {
                            setShowPostEventModal(false)
                            setShowDeclineMeetingModal(true);
                        }
                    }}
                    className="main-btn fill-red-btn w-100 mw-100">
                    <img src={Images.Decline} className="img-fluid"></img>
                    <span>{t("react_decline")}</span>
                </a>
            </div>
        </div>
    );
    const DeclineMeetingModal = ({ event, zoneId }) => {

        const safeEvent = event ?? {};

        const {
            extendedProps = {},
            startStr = "",
            allDay = false
        } = safeEvent;

        const bookingDateStr = startStr;
        const {
            startDate,
            meetingId,
            meetingRepeat,
            repeatOption,
            repeatOptionDay,
            StartTime: eventStartTime,
            EndTime: eventEndTime,
            meetingName,

        } = extendedProps;

        ////console.log("DeclineMeetingModal extendedProps, startDate, meetingId-", extendedProps, startDate, meetingId);
        let titleText = `${t("react_decline")}`;

        const repeatIcon = useMemo(() => {
            if (!repeatOption) return null;          // "" or undefined → no icon
            if (repeatOption === "0") return Images.Time;

            return Images.RepeatEventClock;          // repeat clock icon
        }, [repeatOption]);

        if (!showDeclineMeetingModal) return null;

        return (
            <div>
                <div
                    className="modal"
                    style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    id="dateModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">

                                <div className="close-modal">
                                    <a onClick={(e) => {
                                        e.preventDefault();
                                        setShowDeclineMeetingModal(false);
                                    }}>
                                        <img src={Images.Close} aria-label="Close" />
                                    </a>
                                </div>

                                <div className="pt-4">
                                    <h5 className="popup-title color-pblack">{titleText} <span className="color-green">{meetingName}</span></h5>
                                </div>

                                <div className="divider-line mt-3"></div>
                                <div className="modal-details">
                                    <div className="icon-with-list">
                                        <div className="icon-wrap">
                                            <img src={Images.Participant} />
                                            <h4>{UserName}</h4>
                                        </div>
                                        <>

                                            <div className="icon-wrap">
                                                <img src={Images.GreenCalender} alt="repeat" />
                                                <h4>{formatDateToEEEddMMM(bookingDateStr)}</h4>
                                            </div>

                                            <div className="icon-wrap">
                                                {repeatIcon && <img src={Images.RepeatEventClock} alt="repeat" />}
                                                <h4>
                                                    {t("from")} <span>{eventStartTime}</span> {t("to")} <span> {eventEndTime}</span>
                                                </h4>
                                            </div>
                                            <div className="icon-wrap">
                                                <h4 className="ps-3 ms-3">
                                                    {repeatOption} {repeatOptionDay != "" && repeatOptionDay !== "0" ? `(${repeatOptionDay})` : ""}
                                                </h4>
                                            </div>

                                        </>
                                    </div >
                                </div>
                                {meetingRepeat === 0 && (
                                    <div className="mb-4">
                                        <button className="main-btn fill-green-btn  w-100" href="#"
                                            onClick={async (e) => {
                                                e.preventDefault();
                                                if (!isLoading) {
                                                    DeclineMeeting(zoneId, bookingDateStr, meetingId, 1, startDate);
                                                }
                                            }}
                                        > {t("react_decline")}</button></div>
                                )}

                                {meetingRepeat > 0 && (
                                    <div className="mb-4">
                                        <button
                                            type="button"
                                            className="main-btn fill-green-btn w-100"
                                            onClick={async () => {
                                                if (!isLoading) {
                                                    setShowDeclineMeetingModal(false);
                                                    setShowDeclineMeetingDateSelectModal(true);
                                                }
                                            }}
                                        >
                                            {t("react_decline_occurrence")}
                                        </button>

                                        <button
                                            type="button"
                                            className="main-btn fill-green-btn w-100 mt-2"
                                            onClick={async () => {
                                                if (!isLoading) {
                                                    setShowDeclineMeetingModal(false);
                                                    DeclineMeeting(zoneId, bookingDateStr, meetingId, 1, startDate);
                                                }
                                            }}
                                        >
                                            {t("react_decline_series")}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    const DeclineMeetingDateSelectModal = ({ event, zoneId }) => {
        const [selectedDeclineMeetingDate, setSelectedDeclineMeetingDate] = useState(null);

        const safeEvent = event ?? {};

        const {
            extendedProps = {},
            startStr = "",
        } = safeEvent;

        const bookingDateStr = startStr;

        const {
            startDate,
            lastDateOfBookingAvailable,
            selectedDays,
            meetingId,
            meetingName,
        } = extendedProps;

        const cancelStartDate = startDate || bookingDateStr;

        /* -------------------- HOLIDAYS -------------------- */
        const holidaysArray = holidays || [];
        ////console.log("DeclineMeetingDateSelectModal- holidaysArray ", holidaysArray);
        const holidaysSet = useMemo(
            () => new Set(holidaysArray),
            [holidaysArray]
        );

        /* -------------------- SELECTED DAYS -------------------- */
        const selectedDaysArray = selectedDays || [];

        const selectedDaysSet = useMemo(
            () => new Set(selectedDaysArray),
            [selectedDaysArray]
        );

        const sortedSelectedDays = useMemo(() => {
            if (!selectedDaysArray.length) return [];
            return [...selectedDaysArray].sort(); // yyyy-mm-dd
        }, [selectedDaysArray]);

        const minSelectedDate = sortedSelectedDays[0];
        const maxSelectedDate =
            sortedSelectedDays[sortedSelectedDays.length - 1];
        ////console.log("DeclineMeetingDateSelectModal- minSelectedDate, maxSelectedDate ", minSelectedDate, maxSelectedDate);

        /* -------------------- DATE LOGIC -------------------- */
        function normalizeDate(date) {
            if (!date) return null;

            // If it's already a Date, use it; else convert from string
            const d = date instanceof Date ? date : new Date(date);

            // Check it's valid
            if (isNaN(d.getTime())) return null;

            return d.toISOString().slice(0, 10);
        }


        const isDateAllowedForPicker = (date) => {
            const dateStr = formatDateYYYYMMDD(date);

            // ❌ Holidays
            if (holidaysSet.has(dateStr)) return false;

            // ✅ Selected days logic
            if (selectedDaysSet.size > 0) {
                return selectedDaysSet.has(dateStr);
            }

            // ✅ Range logic
            if (lastDateOfBookingAvailable) {
                const start = normalizeDate(cancelStartDate);
                const end = normalizeDate(lastDateOfBookingAvailable);
                return dateStr >= start && dateStr <= end;
            }

            return true;
        };

        let titleText = `${t("react_decline")} `;

        /* -------------------- CALENDAR RANGE -------------------- */
        const calendarInitialDate =
            selectedDaysSet.size > 0 ? minSelectedDate : cancelStartDate;
        const addOneDay = (dateStr) => {
            const d = new Date(dateStr);
            d.setDate(d.getDate() + 1); // moves to next day
            return d.toISOString().slice(0, 10);
        };

        const calendarValidRange =
            selectedDaysSet.size > 0
                ? {
                    start: minSelectedDate,
                    end: addOneDay(maxSelectedDate),
                }
                : { start: cancelStartDate };

        ////console.log("DeclineMeetingDateSelectModal- calendarValidRange, ", calendarValidRange);
        if (!setShowDeclineMeetingDateSelectModal) return null;
        ////console.log("startDate, lastDateOfBookingAvailable, selectedDays, meetingId=", startDate, lastDateOfBookingAvailable, selectedDays, meetingId)
        return (
            <div>
                <div
                    className="modal"
                    style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">

                                {/* ❌ Close */}
                                <div className="close-modal">
                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setSelectedDeclineMeetingDate(null);
                                            setShowDeclineMeetingDateSelectModal(false);
                                        }}
                                    >
                                        <img src={Images.Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title color-pblack">{titleText} <span className="color-green">{meetingName}</span></h5>
                                </div>
                                <div className="divider-line mt-3 mb-3"></div>
                                {/* 📅 CALENDAR */}
                                <div className="hidden-datepicker-input my-3">
                                    <DatePicker
                                        locale={locale}
                                        minDate={minSelectedDate}
                                        maxDate={maxSelectedDate}
                                        open={open}
                                        inline
                                        filterDate={isDateAllowedForPicker}
                                        onChange={(date) => {
                                            const selected = formatDateYYYYMMDD(date);
                                            //console.log("Allowed date clicked:", selected);
                                            setSelectedDeclineMeetingDate(selected);
                                            //console.log("Allowed date clicked:", selected);
                                            setShowDeclineMeetingDateSelectModal(false);
                                            DeclineMeeting(zoneId, bookingDateStr, meetingId, 2, selected);
                                        }}
                                        dayClassName={(date) =>
                                            isHolidayInList(date) ? "react-datepicker__day--holidayClass" : undefined
                                        }
                                    />

                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const SpotTakenButton = ({ zoneId, bookingDateStr }) => (

        <div className="d-flex justify-content-between align-items-center">
            <button type="button" className="main-btn fill-red-btn w-100" href="#"
                onClick={(e) => {
                    e.preventDefault();
                    if (!isLoading) {
                        setShowPostEventModal(false);
                        setShowAlldayPostEventModal(false);
                        setShowReportParkingViolationModal(true);
                    }
                }}
            >
                <img src={Images.ExclamationCircle} alt="" />
                <span>{t("react_spot_taken")}</span>

            </button>
        </div>
    );
    const ReportParkingViolationModal = ({ zoneId, event }) => {

        const [plateNo, setPlateNo] = useState("");
        const [plateError, setPlateError] = useState("");
        const safeEvent = event ?? {};

        const {
            extendedProps = {},
            startStr = "",
            allDay = false
        } = safeEvent;

        const bookingDateStr = startStr;
        const {
            spotId,
            bookingPeriod,
            StartTime: eventStartTime,
            EndTime: eventEndTime,
            spotName,

        } = extendedProps;

        //console.log("ReportParkingViolationModal extendedProps-", extendedProps);
        let titleText = `${t("react_is_someone_already_parked")}`;
        return (
            <>
                <div id="divReportParkingViolationModal">
                    <div
                        className="modal ctm-modalscroll-modal"
                        style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                        id="dateModal"
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-custom-width">
                            <div className="modal-content modal-radius">
                                <div className="modal-body">
                                    <div className="ctm-modal-header">
                                        <div className="close-modal">
                                            <a onClick={(e) => {
                                                e.preventDefault();
                                                setShowReportParkingViolationModal(false);
                                            }}>
                                                <img src={Images.Close} aria-label="Close" />
                                            </a>
                                        </div>

                                        <div className="pt-4 text-center pe-4">
                                            <h5 className="popup-title text-red pe-0">{titleText} <span>{spotName}?</span></h5>
                                        </div>

                                        <div className="divider-line mt-3"></div>
                                    </div>
                                    <div className="modal-des">
                                        <div className="modal-scroll-inner">
                                            <div className="text-center">
                                                <p>{t("react_enter_license_plate_number")}</p>
                                            </div>
                                            <div>

                                                <div className="form-row">
                                                    <label className="popup-inner-title m-0">{t("license_plate_offender")}</label>
                                                    <input
                                                        type="text"
                                                        className="form-control"
                                                        autoComplete="off"
                                                        value={plateNo}
                                                        onChange={(e) => {
                                                            setPlateNo(e.target.value);
                                                            setPlateError("");

                                                        }}
                                                        placeholder={t("vehicle_plate_placeholder")}
                                                    />
                                                    {plateError && (
                                                        <div className="error-text">
                                                            <img src={Images.ErrorMsg} alt="" />
                                                            <p>{plateError}</p>
                                                        </div>
                                                    )}
                                                </div>
                                                <div className="text-center">
                                                    <p>{t("react_parking_violation_notification")}</p>
                                                </div>
                                            </div >
                                        </div></div>
                                    <div className="ctm-modal-footer">
                                        <button className="main-btn fill-red-btn w-100" href="#"
                                            onClick={async (e) => {
                                                e.preventDefault();
                                                if (!plateNo.trim()) {
                                                    setPlateError(t("react_vehicle_number_plate"));
                                                    return;
                                                }

                                                setShowReportParkingViolationModal(false);
                                                if (!isLoading) {
                                                    await ParkingViolationReporting(zoneId, plateNo, spotId, spotName, bookingPeriod, bookingDateStr);
                                                }
                                            }}
                                        >{t("react_send_to_parking_management")}</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    const AlternateParkingSpotModal = ({ event, zoneId }) => {

        let titleText = `${t("react_parking_violation_reported")}`;
        let topContainerText = "";
        let bottomContainerText = "";
        let btnTxt = "";
        let availableSpotName = "";
        const safeEvent = event ?? {};

        const {
            extendedProps = {},
            startStr = "",
        } = safeEvent;

        //const bookingDateStr = startStr;

        const {
            zoneName
        } = extendedProps;
        //console.log("parkingViolationReportingData--", parkingViolationReportingData);
        if (parkingViolationReportingData) {
            if (parkingViolationReportingData?.Screen === 1) {
                topContainerText = `${t("react_vehicle_parked_wrong_space")}`;
                bottomContainerText = `${t("react_found_alternate_space")} ${parkingViolationReportingData?.Records?.ZoneName}:`;
                availableSpotName = parkingViolationReportingData?.Records?.SpotName;
                btnTxt = `${t("react_yes_take_this_space")}`;
            }
            else if (parkingViolationReportingData?.Screen === 2) {
                topContainerText = `${t("react_parking_violation_reported")}`;
                bottomContainerText = `${t("no_parking_space_available")}`;
                btnTxt = t("confirm");

            }
            else if (parkingViolationReportingData?.Screen === 3) {
                if (parkingViolationReportingData?.Records?.SpotId === 0) {
                    topContainerText = `${t("react_vehicle_not_registered")}`;
                    bottomContainerText = `${t("no_parking_space_available")}`;
                    btnTxt = t("confirm");

                }
                else if (parkingViolationReportingData?.Records?.SpotId > 0) {
                    topContainerText = `${t("react_vehicle_not_registered")}`;
                    bottomContainerText = `${t("react_found_alternate_space")} ${parkingViolationReportingData?.Records?.ZoneName}:`;
                    btnTxt = `${t("react_yes_take_this_space")}`;
                    availableSpotName = parkingViolationReportingData?.Records?.SpotName;
                }
            }
        }
        else return null;

        return (
            <>
                <div id="divAlternateParkingSpotModal">
                    <div
                        className="modal  ctm-modalscroll-modal"
                        style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                        id="dateModal"
                        data-bs-backdrop="static"
                        data-bs-keyboard="false"
                    >
                        <div className="modal-dialog modal-dialog-centered modal-custom-width">
                            <div className="modal-content modal-radius">
                                <div className="modal-body">
                                    <div className="ctm-modal-header">
                                        <div className="close-modal">
                                            <a
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    setShowAlternateParkingSpotModal(false);
                                                }}
                                            >
                                                <img src={Images.Close} aria-label="Close" />
                                            </a>
                                        </div>

                                        <div className="pt-4 text-center">
                                            <h5 className="popup-title pe-3 pb-0">{titleText}</h5>
                                            <div className="d-flex align-items-center justify-content-center gap-2">
                                                <img src={Images.Participant} />
                                                <h4>{parkingViolationReportingData?.Records?.PlateNo}</h4>
                                            </div>
                                        </div>

                                        <div className="pt-1 text-center">
                                            <p>{topContainerText}</p>
                                        </div>
                                        <div className="divider-line mt-3"></div>
                                    </div>
                                    <div className="modal-des">
                                        <div className="modal-scroll-inner">
                                            <div className="text-center my-34">
                                                <img src={Images.ParkingBooking} className="img-fluid" alt="Parking Booking" />
                                            </div>

                                            <div className="modal-details text-center">

                                                <p>{bottomContainerText}
                                                    <h5 className="color-green d-block mt-2 mb-0">{availableSpotName ? availableSpotName : ""}</h5></p>

                                            </div >
                                        </div></div>
                                    <div className="ctm-modal-footer">
                                        <button className="main-btn fill-green-btn w-100" href="#"
                                            onClick={async (e) => {
                                                e.preventDefault();
                                                if (!isLoading) {
                                                    setShowAlternateParkingSpotModal(false);
                                                    if (parkingViolationReportingData?.Records?.SpotId > 0) {
                                                        await AlternateParkingSpotBooking(zoneId);
                                                    }
                                                }
                                            }}
                                        >{btnTxt}</button>
                                        {parkingViolationReportingData?.Records?.SpotId > 0 && (
                                            <div className="d-block w-100">
                                                <a
                                                    className="main-btn cancel-btn gap-2"
                                                    onClick={(e) => {
                                                        e.preventDefault();
                                                        if (!isLoading) {
                                                            setShowAlternateParkingSpotModal(false);
                                                        }
                                                    }}
                                                >
                                                    <span> {t("cancel")}</span>
                                                </a>
                                            </div>

                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
    const GoToMapButton = ({ zoneId, bookingDateStr }) => (

        <a
            onClick={() => GotoMapClick(zoneId, bookingDateStr)}
            className="green-outline-with-icon w-100 mw-100 min-height-56 selected"
        >
            <img src={Images.GreenMap} alt="Map" />
            <span>{t("gotomap")}</span>
        </a>

    );

    const RandomSpaceButton = ({ zoneId, bookingDateStr, disabled = false, }) => (

        <a
            onClick={(e) => {
                e.preventDefault();
                if (disabled || isLoading) return;
                if (!isLoading) {
                    setShowPreEventModal(false);
                    setShowAlldayPreEventModal(false);
                    GetRandomSpace(zoneId, bookingDateStr);
                }
            }}
            href="#"
            className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isLoading || disabled ? 'green-disabled' : ''}`}
            style={{ pointerEvents: isLoading || disabled ? 'none' : 'auto' }}
        >
            {isLoading ? (
                <>
                    <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                    {/* <span>Loading...</span> */}
                </>
            ) : (
                <>
                    <img src={Images.EditSquare} alt="Edit" />
                    <span>{t("get_random_space")}</span>
                </>
            )}
        </a>

    );

    const ScheduleMeetingButton = ({ zoneId, bookingDateStr }) => (

        <a
            onClick={(e) => {
                e.preventDefault();
                if (!isLoading) {
                    ScheduleMeeting(zoneId, bookingDateStr);
                }
            }}
            className="green-outline-with-icon w-100 mw-100 min-height-56"            >
            <img src={Images.ScheduleMeetingicon} alt="Edit" />
            <span>{t("react_schedule_meeting")}</span>
        </a>

    );

    const JoinQueueButton = ({ zoneId, bookingDateStr, disabled = false, }) => (

        <a
            onClick={(e) => {
                e.preventDefault();
                if (isLoading || disabled) return;
                if (!isLoading) {
                    setShowAlldayPreEventModal(false);
                    GetRandomSpace(zoneId, bookingDateStr);
                }
            }}
            className={`green-outline-with-icon w-100 mw-100 min-height-56 ${isLoading || disabled ? 'green-disabled' : ''}`}
            style={{ pointerEvents: isLoading || disabled ? 'none' : 'auto' }}
        >
            {isLoading ? (
                <>
                    <div className="animate-spin h-5 w-5 mr-3 border-t-2 border-b-2 border-green-500 rounded-full"></div>
                    {/* <span>Loading...</span> */}
                </>
            ) : (
                <>
                    <img src={Images.UserInJoinQueue} alt="Queue" />
                    <span>{t("is_queue_status")}</span>
                </>
            )}
        </a>

    );
    const CancelBookingButton = ({ zoneId, bookingDateStr, meetingId }) => (

        <a
            className="main-btn cancel-btn gap-2"
            onClick={(e) => {
                e.preventDefault();
                if (!isLoading) {
                    if (meetingId && meetingId > 0) {
                        setShowPostEventModal(false);
                        setShowAlldayPostEventModal(false);
                        setShowCancelConfirm(false);
                        setShowCancelMeetingModal(true);
                    }
                    else {
                        setShowPostEventModal(false);
                        setShowAlldayPostEventModal(false);
                        setShowCancelMeetingModal(false)
                        setShowCancelConfirm(true);
                    }
                }
            }}
        >
            <span> {t("cancel_booking")}</span>
        </a>

    );

    const CancelBookingConfirmation = ({ event, zoneId }) => {
        //if (!showCancelConfirm) return null;
        const safeEvent = event ?? {};

        const {
            extendedProps = {},
            startStr = "",
            allDay = false
        } = safeEvent;

        const bookingDateStr = startStr;
        const {
            spotId,
            StartTime: eventStartTime,
            EndTime: eventEndTime,
            spotName,

        } = extendedProps;
        setCancelBookingSpotId(spotId);
        //console.log("CancelBookingConfirmation extendedProps-", extendedProps);
        //let titleText = `${t("react_cancel_booking_space")} ${spotName}`;
        return (
            <div>
                <div
                    className="modal"
                    style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    id="dateModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">

                                <div className="close-modal">
                                    <a onClick={(e) => {
                                        e.preventDefault();
                                        setShowCancelConfirm(false);

                                    }}>
                                        <img src={Images.Close} aria-label="Close" />
                                    </a>
                                </div>

                                <div className="pt-4">
                                    {/* <h5 className="popup-title">{titleText}</h5> */}
                                    <h5 className="popup-title color-pblack">
                                        {formatReactString(t("react_cancel_booking_space_s"), [spotName], {
                                            defaultRenderer: () => (
                                                <span className="color-green">{spotName}</span>
                                            )
                                        })}
                                    </h5>
                                </div>

                                <div className="divider-line mt-3"></div>
                                <div className="modal-details">
                                    <div className="booking-name d-flex align-items-center gap-2">
                                        <img src={Images.Participant} />
                                        <h4>{UserName}</h4>
                                    </div>
                                    <>
                                        {/* No start/end time */}
                                        <div className="booking-name d-flex align-items-center gap-2">
                                            <img src={Images.GreenCalender} alt="repeat" />
                                            <h4>{formatDateToEEEddMMM(bookingDateStr)}</h4>
                                        </div>
                                    </>
                                </div >
                                <div className="mb-4">
                                    <button className="main-btn fill-green-btn  w-100" href="#"
                                        onClick={async (e) => {
                                            e.preventDefault();
                                            if (!isLoading) {
                                                setShowCancelConfirm(false);
                                                await CancelBooking(
                                                    zoneId,
                                                    bookingDateStr,
                                                    cancelBookingSpotId
                                                );
                                            }
                                        }}
                                    > {t("confirm")}</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    const CancelMeetingModal = ({ event, zoneId }) => {

        const safeEvent = event ?? {};

        const {
            extendedProps = {},
            startStr = "",
            allDay = false
        } = safeEvent;

        const bookingDateStr = startStr;
        const {
            startDate,
            meetingId,
            meetingRepeat,
            repeatOption,
            repeatOptionDay,
            StartTime: eventStartTime,
            EndTime: eventEndTime,
            meetingName,

        } = extendedProps;

        //console.log("CancelMeetingModal extendedProps, startDate, meetingId-", extendedProps, startDate, meetingId);
        //let titleText = `Cancel ${meetingName}`;

        let titleText = `${t("cancel")}`;
        const repeatIcon = useMemo(() => {
            if (!repeatOption) return null;          // "" or undefined → no icon
            if (repeatOption === "0") return Images.Time;

            return Images.RepeatEventClock;          // repeat clock icon
        }, [repeatOption]);

        if (!showCancelMeetingModal) return null;

        return (
            <div>
                <div
                    className="modal"
                    style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    id="dateModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">

                                <div className="close-modal">
                                    <a onClick={(e) => {
                                        e.preventDefault();
                                        setShowCancelMeetingModal(false);
                                    }}>
                                        <img src={Images.Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title color-pblack">{titleText} <span className="color-green">{meetingName}?</span></h5>
                                </div>

                                <div className="divider-line mt-3"></div>
                                <div className="modal-details">
                                    <>
                                        <div className="icon-with-list">
                                            <div className="icon-wrap">
                                                <img src={Images.Participant} />
                                                <h4>{UserName}</h4>
                                            </div>

                                            <div className="icon-wrap">
                                                <img src={Images.GreenCalender} alt="repeat" />
                                                <h4>{formatDateToEEEddMMM(bookingDateStr)}</h4>
                                            </div>

                                            <div className="icon-wrap">
                                                {repeatIcon && <img src={Images.RepeatEventClock} alt="repeat" />}
                                                <h4>
                                                    {t("from")} <span> {eventStartTime}</span> {t("to")} <span> {eventEndTime}</span>
                                                </h4>
                                            </div>
                                            <div className="icon-wrap">
                                                <h4 className="ps-3 ms-2">
                                                    {repeatOption !== "No repeat" ? repeatOption : ""} {repeatOptionDay && repeatOptionDay !== 0 && repeatOptionDay !== "0" ? `(${repeatOptionDay})` : ""}
                                                </h4>
                                            </div>
                                        </div>
                                    </>
                                </div >
                                {meetingRepeat === 0 && (
                                    <div className="mb-4">
                                        <button
                                            type="button"
                                            className="main-btn fill-green-btn w-100"
                                            disabled={isLoading}
                                            onClick={() => {
                                                CancelMeeting(zoneId, bookingDateStr, meetingId, 1, startDate);
                                            }}
                                        >
                                            {t("cancel")}
                                        </button>
                                    </div>
                                )}

                                {meetingRepeat > 0 && (
                                    <div className="mb-4">
                                        <button
                                            type="button"
                                            className="main-btn fill-green-btn w-100"
                                            onClick={async () => {
                                                if (!isLoading) {
                                                    setShowCancelMeetingModal(false);
                                                    setShowCancelMeetingDateSelectModal(true);
                                                }
                                            }}
                                        >
                                            {t("react_cancel_this_occurrence")}
                                        </button>

                                        <button
                                            type="button"
                                            className="main-btn fill-green-btn w-100 mt-2"
                                            onClick={() => {
                                                if (!isLoading) {
                                                    setShowCancelMeetingModal(false);
                                                    setTimeout(() => {
                                                        CancelMeeting(zoneId, bookingDateStr, meetingId, 1, startDate);
                                                    }, 0);
                                                }
                                            }}
                                        >
                                            {t("react_cancel_the_series")}
                                        </button>

                                        {/* RON-5834: CancelSelect 3 splits the series at the clicked occurrence -
                                            CancelDate is that occurrence's date (startStr can carry a time, so trimmed to YYYY-MM-DD). */}
                                        <button
                                            type="button"
                                            className="main-btn fill-green-btn w-100 mt-2"
                                            onClick={() => {
                                                if (!isLoading) {
                                                    setShowCancelMeetingModal(false);
                                                    setTimeout(() => {
                                                        CancelMeeting(zoneId, bookingDateStr, meetingId, 3, formatDate(bookingDateStr));
                                                    }, 0);
                                                }
                                            }}
                                        >
                                            {t("react_cancel_this_and_following_events")}
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    const CancelMeetingDateSelectModal = ({ event, zoneId }) => {

        let titleText = `${t("cancel")}`;
        const [selectedCancelMeetingDate, setSelectedCancelMeetingDate] = useState(null);

        const safeEvent = event ?? {};

        const {
            extendedProps = {},
            startStr = "",
        } = safeEvent;

        const bookingDateStr = startStr;

        const {
            startDate,
            lastDateOfBookingAvailable,
            selectedDays,
            meetingId,
            meetingName,
        } = extendedProps;

        const cancelStartDate = startDate || bookingDateStr;
        useEffect(() => {
            if (bookingDateStr) {
                setSelectedCancelMeetingDate(new Date(bookingDateStr));
            }
        }, [bookingDateStr]);

        /* -------------------- HOLIDAYS -------------------- */
        const holidaysArray = holidays || [];
        ////console.log("CancelMeetingDateSelectModal- holidaysArray ", holidaysArray);
        const holidaysSet = useMemo(
            () => new Set(holidaysArray),
            [holidaysArray]
        );

        /* -------------------- SELECTED DAYS -------------------- */
        const selectedDaysArray = selectedDays || [];

        const selectedDaysSet = useMemo(
            () => new Set(selectedDaysArray),
            [selectedDaysArray]
        );

        const sortedSelectedDays = useMemo(() => {
            if (!selectedDaysArray.length) return [];
            return [...selectedDaysArray].sort(); // yyyy-mm-dd
        }, [selectedDaysArray]);

        const minSelectedDate = sortedSelectedDays[0];
        const maxSelectedDate =
            sortedSelectedDays[sortedSelectedDays.length - 1];
        ////console.log("CancelMeetingDateSelectModal- minSelectedDate, maxSelectedDate ", minSelectedDate, maxSelectedDate);

        /* -------------------- DATE LOGIC -------------------- */
        function normalizeDate(date) {
            if (!date) return null;

            // If it's already a Date, use it; else convert from string
            const d = date instanceof Date ? date : new Date(date);

            // Check it's valid
            if (isNaN(d.getTime())) return null;

            return d.toISOString().slice(0, 10);
        }
        const isDateAllowedForPicker = (date) => {
            const dateStr = formatDateYYYYMMDD(date);

            // ❌ Holidays
            if (holidaysSet.has(dateStr)) return false;

            // ✅ Selected days logic
            if (selectedDaysSet.size > 0) {
                return selectedDaysSet.has(dateStr);
            }

            // ✅ Range logic
            if (lastDateOfBookingAvailable) {
                const start = normalizeDate(cancelStartDate);
                const end = normalizeDate(lastDateOfBookingAvailable);
                return dateStr >= start && dateStr <= end;
            }
            return true;
        };

        const toDateObject = (yyyyMMdd) => {
            if (!yyyyMMdd) return null;
            const [y, m, d] = yyyyMMdd.split("-").map(Number);
            return new Date(y, m - 1, d);
        };

        const minDate = lastDateOfBookingAvailable
            ? toDateObject(normalizeDate(cancelStartDate))
            : null;

        const maxDate = lastDateOfBookingAvailable
            ? toDateObject(normalizeDate(lastDateOfBookingAvailable))
            : null;

        /* -------------------- CALENDAR RANGE -------------------- */
        const calendarInitialDate =
            selectedDaysSet.size > 0 ? minSelectedDate : cancelStartDate;
        const addOneDay = (dateStr) => {
            const d = new Date(dateStr);
            d.setDate(d.getDate() + 1); // moves to next day
            return d.toISOString().slice(0, 10);
        };

        const calendarValidRange =
            selectedDaysSet.size > 0
                ? {
                    start: minSelectedDate,
                    end: addOneDay(maxSelectedDate),
                }
                : { start: cancelStartDate };

        ////console.log("CancelMeetingDateSelectModal- calendarValidRange, ", calendarValidRange);
        if (!setShowCancelMeetingDateSelectModal) return null;
        ////console.log("bookingDateStr,startDate, lastDateOfBookingAvailable, selectedDays, meetingId=", bookingDateStr, startDate, lastDateOfBookingAvailable, selectedDays, meetingId)
        return (
            <div>
                <div
                    className="modal"
                    style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">

                                {/* ❌ Close */}
                                <div className="close-modal">


                                    <a
                                        onClick={(e) => {
                                            e.preventDefault();
                                            setSelectedCancelMeetingDate(null);
                                            setShowCancelMeetingDateSelectModal(false);
                                        }}
                                    >
                                        <img src={Images.Close} aria-label="Close" />
                                    </a>
                                </div>
                                <div className="pt-4">
                                    <h5 className="popup-title color-pblack">{titleText} <span className="color-green">{meetingName}</span></h5>
                                </div>
                                <div className="divider-line mt-3 mb-3"></div>
                                {/* 📅 CALENDAR */}
                                <div className="hidden-datepicker-input my-3">
                                    <DatePicker
                                        locale={locale}
                                        selected={selectedCancelMeetingDate}
                                        minDate={minSelectedDate}
                                        maxDate={maxSelectedDate}
                                        open={open}
                                        inline
                                        filterDate={isDateAllowedForPicker}
                                        onChange={(date) => {
                                            const selected = formatDateYYYYMMDD(date);
                                            //console.log("Allowed date clicked:", selected);

                                            setSelectedCancelMeetingDate(date);
                                            setShowCancelMeetingDateSelectModal(false);
                                            CancelMeeting(zoneId, bookingDateStr, meetingId, 2, selected);
                                        }}
                                        dayClassName={(date) =>
                                            isHolidayInList(date) ? "react-datepicker__day--holidayClass" : undefined
                                        }
                                    />

                                </div>

                                {/* ❌ Cancel Button */}
                                {/* <div className="mb-4 mt-3">
                                    <button
                                        className="main-btn fill-green-btn w-100"
                                        onClick={() => {
                                            CancelMeeting(zoneId, bookingDateStr, meetingId, 2, selectedCancelMeetingDate);
                                            setShowCancelMeetingDateSelectModal(false);
                                        }}
                                    >
                                        Cancel
                                    </button>
                                </div> */}

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    /* ---------------------------------------------------------------------
     * RON-5375: legacy Reschedule flow - COMMENTED OUT, kept for reference.
     * The single Reschedule button was replaced by EditMeetingButtons, which
     * opens the shared NewMeetingModal in edit mode (see EditMeetingButtons
     * below and the edit-mode NewMeetingModal render at the end of the file).
     * Disabled here: ReScheduleMeetingButton, ReScheduleMeetingModal,
     * ReScheduleMeetingDateSelectModal and the RescheduleMeeting API call.
     * ------------------------------------------------------------------- */
    // const ReScheduleMeetingButton = ({ zoneId, bookingDateStr }) => (
        // <div className="mb-3">
            // <a
                // onClick={(e) => {
                    // e.preventDefault();
                    // if (!isLoading) {
                        // setSelectedRescheduleDate(bookingDateStr);
                        // setShowPostEventModal(false);
                        // setShowRescheduleMeetingModal(true);
                    // }
                // }}
                // className="green-outline-with-icon w-100 mw-100 min-height-56"            >
                // {/* <img src={Images.edit} alt="Edit" /> */}
                // <span>{t("react_reschedule")}</span>
            // </a>
        // </div>
    // );

    // const ReScheduleMeetingModal = ({
        // selectedZoneId,
        // event,
        // selectedRescheduleDate,
        // setSelectedRescheduleDate,
        // setShowReScheduleMeetingDateSelectModal
    // }) => {
        // const safeEvent = event ?? {};
        // const { extendedProps = {}, startStr = "" } = safeEvent;

        // const bookingDateStr = startStr;
        // const [showDateInput, setShowDateInput] = useState(false);
        // useEffect(() => {
            // if (rescheduledBookingOccurrence === 1) {
                // setShowDateInput(false);
            // } else if (rescheduledBookingOccurrence === 2) {
                // setShowDateInput(true);
            // }
        // }, [rescheduledBookingOccurrence]);

        // const [selectedFrom, setSelectedFrom] = useState("");
        // const [selectedTo, setSelectedTo] = useState("");

        // const [showSlots, setShowSlots] = useState(false);
        // const [activePicker, setActivePicker] = useState(null);
        // const [timeError, setTimeError] = useState("");
        // const resetRescheduleMeetingModal = () => {
            // setTimeError("");
            // setSelectedFrom("");
            // setSelectedTo("");
            // setShowSlots(false);
            // setActivePicker(null);
            // setRescheduledBookingOccurrence(0);
            // setShowDateInput(false);
            // setSelectedRescheduleDate("");
        // };
        // const {
            // meetingRepeat,
            // isApproversExist,
            // showApproverDate,
            // meetingId,
            // meetingName,
            // timeIntervals = []   // ✅ important default
        // } = extendedProps;

        // const handleSlotClick = (time) => {
            // setTimeError("");
            // ////console.log("handleSlotClick time-", time, activePicker);
            // if (activePicker === "FROM") {
                // setSelectedFrom(time);

                // // reset end if invalid
                // if (timeIntervals.indexOf(selectedTo) <= timeIntervals.indexOf(time)) {
                    // setSelectedTo("00:00");
                // }
                // setShowSlots(false);
                // setActivePicker(null);
                // return;
            // }

            // if (activePicker === "TO") {
                // if (timeIntervals.indexOf(time) <= timeIntervals.indexOf(selectedFrom)) {
                    // setTimeError(t("react_end_time_gt_start"));
                    // return;
                // }
                // setSelectedTo(time);
                // setShowSlots(false);
                // setActivePicker(null);
            // }
        // };

        // // 🔹 Handlers
        // const openFromPicker = () => {
            // setActivePicker("FROM");
            // setShowSlots(true);
            // setTimeError("");
        // };

        // const openToPicker = () => {
            // if (!selectedFrom) {
                // setTimeError(t("react_please_select_start_time"));
                // return;
            // }
            // setActivePicker("TO");
            // setShowSlots(true);
            // setTimeError("");
        // };

        // // 1️⃣ Dropdown visibility
        // const showDropdown = meetingRepeat !== 0;

        // // 2️⃣ Option visibility
        // let showAlloccurrence = false;
        // let showSelectDate = false;

        // if (isApproversExist === 1) {
            // showAlloccurrence = true;

            // if (showApproverDate == 0) {
                // showSelectDate = true;
            // }
        // }
        // else {
            // showAlloccurrence = true;
            // showSelectDate = true;
        // }

        // // 3️⃣ Build options dynamically
        // const rescheduledBookingOccurrenceOptions = [];

        // if (showAlloccurrence) {
            // rescheduledBookingOccurrenceOptions.push({
                // id: 1,
                // name: `${t("react_all_occurrences")}`
            // });
        // }

        // if (showSelectDate) {
            // rescheduledBookingOccurrenceOptions.push({
                // id: 2,
                // name: `${t("select")} ${t("date")}`
            // });
        // }

        // useEffect(() => {
            // const firstOptionId = rescheduledBookingOccurrenceOptions[0]?.id;

            // if (
                // showDropdown &&
                // firstOptionId !== undefined &&
                // !rescheduledBookingOccurrenceOptions.some(
                    // (option) => option.id === rescheduledBookingOccurrence
                // )
            // ) {
                // setRescheduledBookingOccurrence(firstOptionId);
            // }
        // }, [showDropdown, rescheduledBookingOccurrenceOptions, rescheduledBookingOccurrence]);


        // //console.log("ReScheduleMeetingModal extendedProps, meetingId-", extendedProps, meetingId);
        // let titleText = `${t("react_when_reschedule")}`;

        // const repeatIcon = useMemo(() => {
            // if (!repeatOption) return null;          // "" or undefined → no icon
            // if (repeatOption === "0") return Images.Time;

            // return Images.RepeatEventClock;          // repeat clock icon
        // }, [repeatOption]);

        // if (!showRescheduleMeetingModal) return null;

        // return (
            // <div>
                // <div
                    // className="modal ctm-modalscroll-modal"
                    // style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    // id="dateModal"
                    // data-bs-backdrop="static"
                    // data-bs-keyboard="false"
                // >
                    // <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        // <div className="modal-content modal-radius">
                            // <div className="modal-body">
                                // <div className="ctm-modal-header">
                                    // <div className="close-modal">
                                        // <a onClick={(e) => {
                                            // e.preventDefault();
                                            // resetRescheduleMeetingModal();
                                            // setShowRescheduleMeetingModal(false);
                                        // }}>
                                            // <img src={Images.Close} aria-label="Close" />
                                        // </a>
                                    // </div>

                                    // <div className="pt-4">
                                        // <h5 className="popup-title">{titleText}</h5>
                                    // </div>

                                    // <div className="divider-line mt-3"></div>
                                // </div>
                                // <div className="modal-des">
                                    // <div className="modal-scroll-inner">
                                        // <div className="icon-wrap mb-3">
                                            // <img src={Images.ZoneMap} className="img-fluid" alt="spot" />
                                            // <span className="zone_text"> {zoneName}</span>
                                        // </div>
                                        // {showDropdown && (
                                            // <div className="form-row">
                                                // <label className="popup-inner-title m-0">{t("react_type_label")}</label>
                                                // <CustomSearchableDropdown
                                                    // items={rescheduledBookingOccurrenceOptions}
                                                    // value={rescheduledBookingOccurrence}
                                                    // labelKey="name"
                                                    // valueKey="id"
                                                    // searchable={false}
                                                    // onChange={(value) => {
                                                        // const reoccurrenceValue = Number(value);
                                                        // setRescheduledBookingOccurrence(reoccurrenceValue);

                                                        // if (reoccurrenceValue === 1) {
                                                            // setSelectedRescheduleDate("");
                                                            // setShowDateInput(false);
                                                        // } else if (reoccurrenceValue === 2) {
                                                            // setShowDateInput(true);
                                                        // }
                                                    // }}
                                                // />
                                            // </div>
                                        // )}


                                        // {showDateInput && (
                                            // <div className="form-row mt-2">
                                                // <input
                                                    // type="text"
                                                    // className="form-control"
                                                    // autoComplete="off"
                                                    // readOnly
                                                    // value={formatDateToEEEddMMM(selectedRescheduleDate)}
                                                    // placeholder={t("please_select_date")}
                                                    // onClick={() => {
                                                        // setShowRescheduleMeetingModal(false);
                                                        // setShowReScheduleMeetingDateSelectModal(true);
                                                    // }
                                                    // }

                                                // />
                                            // </div>
                                        // )}

                                        // {/* Select Time Slots */}
                                        // <div className="custom-timepicker">
                                            // <h6 className="popup-inner-title">{t("react_select_time")}</h6>
                                            // <div
                                                // className="selected-box"
                                                // id="selectedBox"
                                            // >
                                                // <div onClick={openFromPicker}>
                                                    // {t("from")} <span>{selectedFrom || "00:00"}</span>
                                                // </div>

                                                // <div>→</div>

                                                // <div onClick={openToPicker}>
                                                    // {t("to")} <span>{selectedTo || "00:00"}</span>
                                                // </div>
                                            // </div>
                                            // {timeError && (
                                                // <div className="error-text"><img src={Images.ErrorMsg}></img> <p>{timeError}</p></div>
                                            // )}

                                            // {showSlots && (
                                                // <div className="slot-container d-grid mb-3">
                                                    // {timeIntervals.map((time, idx) => {
                                                        // const isSelected =
                                                            // time === selectedFrom || time === selectedTo;

                                                        // return (
                                                            // <div
                                                                // key={idx}
                                                                // className={`slot ${isSelected ? "active" : ""}`}
                                                                // onClick={() => handleSlotClick(time)}
                                                            // >
                                                                // {time}
                                                            // </div>
                                                        // );
                                                    // })}
                                                // </div>
                                            // )}
                                        // </div>
                                    // </div>

                                // </div >
                                // <div className="ctm-modal-footer">
                                    // <button className="main-btn fill-green-btn w-100" href="#"
                                        // onClick={async (e) => {
                                            // e.preventDefault();
                                            // if (isLoading) return;

                                            // if (!selectedFrom) {
                                                // setTimeError(t("select") + " " + t("start_time"));
                                                // return;
                                            // }

                                            // if (!selectedTo || selectedTo === "00:00") {
                                                // setTimeError(t("select") + " " + t("end_time"));
                                                // return;
                                            // }

                                            // if (timeIntervals.indexOf(selectedTo) <= timeIntervals.indexOf(selectedFrom)) {
                                                // setTimeError(t("react_end_time_must_be_greater_than_start_time"));
                                                // return;
                                            // }
                                            // if (timeIntervals.indexOf(selectedFrom) < timeIntervals.indexOf(selectedTo)) {
                                                // setShowRescheduleMeetingModal(false);
                                                // RescheduleMeeting(selectedZoneId, selectedFrom, selectedTo, rescheduledBookingOccurrence, bookingDateStr, meetingId, selectedRescheduleDate);
                                            // }

                                        // }}
                                    // >{t("confirm")}</button>
                                // </div>
                            // </div>
                        // </div>
                    // </div>
                // </div>
            // </div>
        // );
    // }
    // const ReScheduleMeetingDateSelectModal = ({ zoneId, event, selectedRescheduleDate, onDateSelect }) => {
        // const [selectedReScheduleMeetingDate, setSelectedReScheduleMeetingDate] = useState(null);

        // const safeEvent = event ?? {};

        // const {
            // extendedProps = {},
            // startStr = "",
        // } = safeEvent;

        // const bookingDateStr = startStr;

        // const {
            // startDate,
            // lastDateOfBookingAvailable,
            // selectedDays,
            // meetingId,
            // meetingName,
        // } = extendedProps;

        // const cancelStartDate = startDate || bookingDateStr;
        // useEffect(() => {
            // const dateToSelect = selectedRescheduleDate || bookingDateStr;

            // if (dateToSelect) {
                // setSelectedReScheduleMeetingDate(new Date(dateToSelect));
            // }
        // }, [selectedRescheduleDate, bookingDateStr]);

        // /* -------------------- HOLIDAYS -------------------- */
        // const holidaysArray = holidays || [];
        // ////console.log("ReScheduleMeetingDateSelectModal- holidaysArray ", holidaysArray);
        // const holidaysSet = useMemo(
            // () => new Set(holidaysArray),
            // [holidaysArray]
        // );

        // /* -------------------- SELECTED DAYS -------------------- */
        // const selectedDaysArray = selectedDays || [];

        // const selectedDaysSet = useMemo(
            // () => new Set(selectedDaysArray),
            // [selectedDaysArray]
        // );

        // const sortedSelectedDays = useMemo(() => {
            // if (!selectedDaysArray.length) return [];
            // return [...selectedDaysArray].sort(); // yyyy-mm-dd
        // }, [selectedDaysArray]);

        // const minSelectedDate = sortedSelectedDays[0];
        // const maxSelectedDate =
            // sortedSelectedDays[sortedSelectedDays.length - 1];
        // ////console.log("ReScheduleMeetingDateSelectModal- minSelectedDate, maxSelectedDate ", minSelectedDate, maxSelectedDate);

        // /* -------------------- DATE LOGIC -------------------- */
        // function normalizeDate(date) {
            // if (!date) return null;

            // // If it's already a Date, use it; else convert from string
            // const d = date instanceof Date ? date : new Date(date);

            // // Check it's valid
            // if (isNaN(d.getTime())) return null;

            // return d.toISOString().slice(0, 10);
        // }


        // const isDateAllowedForPicker = (date) => {
            // const dateStr = formatDateYYYYMMDD(date);
            // // ❌ Holidays
            // if (holidaysSet.has(dateStr)) return false;

            // // ✅ Selected days logic
            // if (selectedDaysSet.size > 0) {
                // return selectedDaysSet.has(dateStr);
            // }

            // // ✅ Range logic
            // if (lastDateOfBookingAvailable) {
                // const start = normalizeDate(cancelStartDate);
                // const end = normalizeDate(lastDateOfBookingAvailable);
                // return dateStr >= start && dateStr <= end;
            // }

            // return true;
        // };



        // /* -------------------- CALENDAR RANGE -------------------- */
        // const calendarInitialDate =
            // selectedDaysSet.size > 0 ? minSelectedDate : cancelStartDate;
        // const addOneDay = (dateStr) => {
            // const d = new Date(dateStr);
            // d.setDate(d.getDate() + 1); // moves to next day
            // return d.toISOString().slice(0, 10);
        // };
        // let titleText = `${t("react_rescheule")} `;
        // const calendarValidRange =
            // selectedDaysSet.size > 0
                // ? {
                    // start: minSelectedDate,
                    // end: addOneDay(maxSelectedDate),
                // }
                // : { start: cancelStartDate };

        // //console.log("ReScheduleMeetingDateSelectModal- calendarValidRange, ", calendarValidRange);
        // if (!setShowReScheduleMeetingDateSelectModal) return null;
        // ////console.log("bookingDateStr,startDate, lastDateOfBookingAvailable, selectedDays, meetingId=", bookingDateStr, startDate, lastDateOfBookingAvailable, selectedDays, meetingId)
        // return (
            // <div>
                // <div
                    // className="modal"
                    // style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    // data-bs-backdrop="static"
                    // data-bs-keyboard="false"
                // >
                    // <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        // <div className="modal-content modal-radius">
                            // <div className="modal-body">

                                // {/* ❌ Close */}
                                // <div className="close-modal">
                                    // <a
                                        // onClick={(e) => {
                                            // e.preventDefault();
                                            // setSelectedReScheduleMeetingDate(null);
                                            // setShowReScheduleMeetingDateSelectModal(false);
                                            // setShowRescheduleMeetingModal(false);
                                            // setRescheduledBookingOccurrence(1);
                                            // setSelectedRescheduleDate("");
                                        // }}
                                    // >
                                        // <img src={Images.Close} aria-label="Close" />
                                    // </a>

                                // </div>
                                // <div className="pt-4">
                                    // <h5 className="popup-title color-pblack">{titleText} <span className="color-green">{meetingName}</span></h5>
                                // </div>
                                // <div className="divider-line mt-3 mb-3"></div>
                                // {/* 📅 CALENDAR */}
                                // <div className="hidden-datepicker-input">
                                    // <DatePicker
                                        // locale={locale}
                                        // selected={selectedReScheduleMeetingDate}
                                        // minDate={minSelectedDate}
                                        // maxDate={maxSelectedDate}
                                        // open={open}
                                        // inline
                                        // filterDate={isDateAllowedForPicker}
                                        // onChange={(date) => {
                                            // setSelectedReScheduleMeetingDate(date);
                                            // const selected = formatDateYYYYMMDD(date);
                                            // //console.log("Allowed date clicked:", selected);
                                            // if (!isDateAllowedForPicker(selected)) return;
                                            // onDateSelect(selected);
                                            // setShowReScheduleMeetingDateSelectModal(false);
                                        // }}
                                    // />

                                // </div>


                            // </div>
                        // </div>
                    // </div>
                // </div>
            // </div>
        // );
    // };

    // async function RescheduleMeeting(zoneId, startTime, endTime, rescheduledBookingOccurrence, bookingDateStr, meetingId, RescheduledDate) {
        // /* console.log(
            // `Reschedule Meeting Clicked: zoneId=${zoneId}, startTime=${startTime}, endTime=${endTime}, rescheduledBookingOccurrence=${rescheduledBookingOccurrence},
            // bookingDateStr=${bookingDateStr}, meetingId=${meetingId}, RescheduledDate=${formatDate(RescheduledDate)}`
        // ); */
        // try {
            // if (isLoading) return;
            // setIsLoading(true);
            // setLoadingDates((prev) => [...prev, bookingDateStr]);
            // const reqParams = {
                // BookingId: meetingId,
                // StartTime: startTime,
                // EndTime: endTime,
                // RescheduledDate: formatDate(RescheduledDate),
                // RescheduledBookingOccurrence: rescheduledBookingOccurrence,
            // };

            // const response = await RescheduleMeeting_api(reqParams);

            // setShowRescheduleMeetingModal(false);
            // //const result = handleResponseCode(response);
            // /* handleApiResponse(response, setNotification, t, {
                // successMsg: 1,
                // errorMsg: 1
            // }); */
            // handleApiUiResponse(response, {
                // successToaster: 1,
                // errorToaster: 1,
                // alertPopup: 1
            // });
            // if (response?.Data?.ResponseCode === 200) {

                // await delay(1000);
                // setSelectedRescheduleDate("");
                // setRescheduledBookingOccurrence(0);
                // await fetchBookings(zoneId, getVisibleWeekStartDateString(selectedDate));
                // resetValues();
                // setIsLoading(false);
            // } else {
                // console.error("Reschedule meeting failed:", response?.Data?.ResponseMessage);
            // }
        // } catch (error) {
            // console.error("Error calling RescheduleMeeting_api:", error);

        // } finally {
            // setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            // setIsLoading(false);
        // }
    // }
    // ----- end RON-5375 legacy Reschedule flow (commented out) -----

    // RON-5375: opens NewMeetingModal in edit mode.
    // "Edit this event" (RescheduleType 2) is always available; "Edit all events in
    // this series" (RescheduleType 1) and "Edit this and all following events"
    // (RescheduleType 3) are shown only for recurring meetings (MeetingRepeat > 0).
    const EditMeetingButtons = ({ meetingRepeat }) => {
        const openEditMeeting = (rescheduleType) => {
            if (isLoading) return;
            setEditRescheduleType(rescheduleType);
            setShowPostEventModal(false);
            setShowEditMeetingModal(true);
        };

        return (
            <>
                <div className="mb-3">
                    <a
                        href="#"
                        onClick={(e) => {
                            e.preventDefault();
                            openEditMeeting(2);
                        }}
                        className="green-outline-with-icon w-100 mw-100 min-height-56"
                    >
                        <img src={Images.EditEventIcon} alt="" className="img-fluid" />
                        <span>{t("react_edit_this_event")}</span>
                    </a>
                </div>

                {meetingRepeat > 0 && (
                    <>
                        <div className="mb-3">
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    openEditMeeting(1);
                                }}
                                className="green-outline-with-icon w-100 mw-100 min-height-56"
                            >
                                <img src={Images.EditAllSeriesIcon} alt="" className="img-fluid" />
                                <span>{t("react_edit_all_events_in_series")}</span>
                            </a>
                        </div>

                        <div className="mb-3">
                            <a
                                href="#"
                                onClick={(e) => {
                                    e.preventDefault();
                                    openEditMeeting(3);
                                }}
                                className="green-outline-with-icon w-100 mw-100 min-height-56"
                            >
                                <img src={Images.EditFollowingEventsIcon} alt="" className="img-fluid" />
                                <span>{t("react_edit_this_and_following_events")}</span>
                            </a>
                        </div>
                    </>
                )}
            </>
        );
    };

    const PreEventModal = ({ zoneId, onClose }) => {
        const { bookingDateStr, bookingForModal } = useBookingContext(clickedFullDay, weekData);
        const { displayMonth, displayYear } = useBookingDisplayDate(clickedFullDay, setSelectedDay);

        /* -------------------- VEHICLE DROPDOWN -------------------- */

        const vehicleList = useMemo(() => {
            if (!bookingForModal?.EmployeeVehicleType) return [];

            return bookingForModal.EmployeeVehicleType.map(v => ({
                VehicleId: String(v.VehiclePrimaryKey),
                VehicleLabel: String(v.VehicleRegistrationId),
            }));
        }, [bookingForModal?.EmployeeVehicleType]);

        const isRandomSpaceDisabled = Boolean(preBookingQuestion) && !checkedPreBookingQue;
        const isJoinQueueDisabled = Boolean(preBookingQuestion) && !checkedPreBookingQue;

        let titleText = `${t("react_calendar_new_booking")}`;
        if (displayQueue === 1) {
            titleText = t("react_no_space_left");
        }

        const safeHtml = DOMPurify
            .sanitize(preBookingQuestion)
            .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');

        /* -------------------- ACTION BUTTONS -------------------- */

        const renderActionButtons = () => {

            if (!bookingForModal) return null;
            //console.log("Pre Event Modal Testing");
            return (
                <>
                    {/* GoTo Map Button */}
                    {(mapAvailable === 1 && mapAvailableType !== 1) && (
                        <GoToMapButton zoneId={zoneId} bookingDateStr={bookingDateStr} />
                    )}
                    {/* Schedule Meeting Button */}
                    {(meetingRoomAvailable === 1) && (
                        <ScheduleMeetingButton zoneId={zoneId} bookingDateStr={bookingDateStr} isLoading={isLoading} />
                    )}
                </>
            );
        }
        /* -------------------- JSX -------------------- */

        return (
            <div>
                <div
                    className="modal ctm-modalscroll-modal"
                    style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    id="dateModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="ctm-modal-header">
                                    <div className="close-modal">
                                        <a onClick={onClose}>
                                            <img src={Images.Close} aria-label="Close" />
                                        </a>
                                    </div>

                                    <div className="pt-4">
                                        <h5 className="popup-title">{titleText}</h5>
                                    </div>

                                    <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                        <div className="selected-current-date">
                                            <span>{selectedDay}</span>
                                            <span>{t(displayMonth)} {displayYear}</span>
                                        </div>
                                        {/* Show CREDIT */}
                                        {zoneCreditValue > 0 && (
                                            <div className="credit-info">
                                                <a
                                                    href="#"
                                                    className="orange-outline-with-icon"
                                                    onClick={(e) => e.preventDefault()}
                                                >
                                                    {individualDayCost === 0 || individualDayCost === "0" ? (
                                                        <>
                                                            <img src={Images.GrayStar} alt="star" />
                                                            <span>{individualDayCost}</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <img src={Images.OrangeStar} alt="star" />
                                                            <span>
                                                                {isExistingEvent === false && (`-${individualDayCost}`)}
                                                            </span>
                                                        </>
                                                    )}
                                                </a>
                                            </div>
                                        )}
                                    </div>

                                    <div className="divider-line mt-3"></div>
                                </div>
                                <div className="modal-des">
                                    <div className="modal-scroll-inner">
                                        <div className="booking-name d-flex align-items-center gap-2">
                                            <img src={Images.Participant} />
                                            <h4>{UserName}</h4>
                                        </div>
                                        {/* PreBookingQuestion */}
                                        <div className="participants-list ctm-checklist">
                                            {!!preBookingQuestion && (
                                                <div
                                                    className={`form-check ${checkedPreBookingQue ? "check-active" : ""
                                                        }`}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`preBookingQuestion`}
                                                        checked={checkedPreBookingQue}
                                                        onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                                    />

                                                    <label
                                                        className="form-check-label ms-2"
                                                        htmlFor={`preBookingQuestion`}
                                                    >
                                                        <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                                    </label>
                                                </div>
                                            )}
                                        </div>
                                        {/* {!!preBookingQuestion && (
                                        <div className="booking-name d-flex align-items-center gap-2">
                                            <label className="popup-inner-title m-0" >
                                                <input
                                                    type="checkbox"
                                                    checked={checkedPreBookingQue}
                                                    onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                                    style={{ accentColor: "green" }}
                                                />
                                                {preBookingQuestion}
                                            </label>
                                        </div>
                                    )} */}
                                        <div className="text-center my-34">
                                            {zoneType === 1 ? (
                                                <img src={Images.ParkingBooking} className="img-fluid" alt="Parking Booking" />
                                            ) : zoneType === 2 && meetingRoomAvailable === 1 && bookingForModal?.HourlySpotAvailable === 0 && bookingForModal?.DeskAvailable === 0 ? (
                                                <img src={Images.Meeting} className="img-fluid" alt="Meeting" />
                                            ) : zoneType === 2 ? (
                                                <img src={Images.Deskbooking} className="img-fluid" alt="Desk Booking" />
                                            ) : null}
                                        </div>
                                    </div>
                                </div>

                                <div className="ctm-modal-footer">
                                    {renderActionButtons()}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const PostEventModal = ({ onClose, zoneId, event }) => {

        //console.log("PostEventModal mounted, event =", event);

        const safeEvent = event ?? {};

        const {
            extendedProps = {},
            startStr = "",
            allDay = false
        } = safeEvent;

        const bookingDateStr = startStr;

        // ✅ Hook is ALWAYS called
        const { displayMonth, displayYear } =
            useBookingDisplayDate(bookingDateStr, setSelectedDay);

        const {
            spotTagList,
            spotId,
            spotType,
            checkInFlag,
            checkInType,
            bookingPeriod,
            repeatOption,
            StartTime: eventStartTime,
            EndTime: eventEndTime,
            meetingName,
            organiserName,
            showReportLabel,
            spotName,
            organiserId,
            userId,
            isApproversExist,
            meetingApproveStatus,
            isApprover,
            //showLeaveQueue,
            queuePosition,
            meetingId,
            meetingRepeat,   // RON-5375: drives the "Edit all events in the series" button
            zoneType,
            zoneCurrentDateTime,
            fullRefundCredit,
            halfRefundCredit,
            noRefundCredit,
            refundStartDateTime,
            refundEndDateTime
        } = extendedProps;

        //console.log("event.extendedProps.spotId of PostEventModal - ", event.extendedProps.spotId);
        ////console.log("SpotId of PostEventModal - ", spotId);

        ////console.log("deskAvailable of PostEventModal - ", deskAvailable);
        ////console.log("spotId,spotType,bookingPeriod,joinedQueue,queuePosition,spotName,organiserId,userId,isApproversExist,meetingApproveStatus,isApprover,showReportLabel,checkInFlag,checkInType,repeatOption,eventStartTime,eventEndTime--",
        //            spotId, spotType, bookingPeriod, joinedQueue, queuePosition, spotName, organiserId, userId, isApproversExist, meetingApproveStatus, isApprover, showReportLabel, checkInFlag, checkInType, repeatOption, eventStartTime, eventEndTime)

        const hasBookingDate = Boolean(bookingDateStr);
        const displayCreditValue = getDisplayRefundCreditValue({
            refundStartDateTime,
            refundEndDateTime,
            zoneCurrentDateTime,
            fullRefundCredit,
            halfRefundCredit,
            noRefundCredit
        });
        const isZeroDisplayCredit =
            displayCreditValue === 0 || displayCreditValue === "0";

        const isHourlyBooking = spotType === 3 || bookingPeriod === 2;

        const hasTime = eventStartTime && eventEndTime;
        const hasNoTime = !eventStartTime && !eventEndTime;

        const showLeaveQueue = ((zoneType === 1 && spotType === 1) || (zoneType === 2 && spotType === 2))
            && (bookingPeriod === 1 && joinedQueue === 1);

        ////console.log("zoneType,spotType,bookingPeriod,joinedQueue--->", zoneType, spotType, bookingPeriod, joinedQueue);
        ////console.log("showLeaveQueue--->", showLeaveQueue);
        const isCheckIn = (checkInType.length > 0 && (checkInType.includes(2)) && spotId >= 0 && (checkInFlag === 0 || checkInFlag === 2));
        const showCheckOut = checkInType.includes(0) ? false : true;

        const isSpotType3 = spotType === 3;
        const isOrganiserEqualUser = organiserId === userId;
        const hasApprovers = isApproversExist === 1;

        const canRescheduleByApproval =
            meetingApproveStatus === 0 ||
            meetingApproveStatus === 5 ||
            (isApprover === 1 && meetingApproveStatus === 1);
        let showCancelButton = true;

        let showRescheduleButton = false;
        let showDeclineButton = false;

        //if (totalBookings > 0) { showCancelButton = true; }
        if (showLeaveQueue) { showCancelButton = false; }

        if (isSpotType3) {

            if (!isOrganiserEqualUser) {         // OrganiserId != UserId

                showCancelButton = false;
                showRescheduleButton = false;
                showDeclineButton = true;

            } else {                            // OrganiserId == UserId

                showDeclineButton = false;
                showCancelButton = true;

                if (hasApprovers) {
                    showRescheduleButton = canRescheduleByApproval;
                } else {
                    showRescheduleButton = true;
                }
            }
        }

        ////console.log("totalBookings--->", totalBookings);
        ////console.log("showCancelButton-->", showCancelButton);

        let titleText = "";
        if (showLeaveQueue) {
            if (queuePosition === 0)
                titleText = t("react_you_are_on_waitlist");
            else {
                titleText = formatReactString(t("react_waiting_position"), [queuePosition], {
                    defaultRenderer: (val) => (
                        <span className="color-dark-black">{queuePosition}</span>
                    )
                });
            }
        }
        else if (!showLeaveQueue || (zoneType === 2 && spotType === 3 && !isOrganiserEqualUser)) {
            titleText = formatReactString(t("YourBookingForSpace"), [spotName], {
                defaultRenderer: (val) => (
                    <span className="color-dark-black">{spotName}</span>
                )
            });
        }
        else if (zoneType === 2 && spotType === 3 && isOrganiserEqualUser) {
            titleText = formatReactString(t("react_invited_for"), [spotName], {
                defaultRenderer: (val) => (
                    <span className="color-dark-black">{spotName}</span>
                )
            });
        }
        else {
            titleText = formatReactString(t("YourBookingForSpace"), [spotName], {
                defaultRenderer: (val) => (
                    <span className="color-dark-black">{spotName}</span>
                )
            });
        }

        const repeatIcon = useMemo(() => {
            if (!repeatOption) return null;          // "" or undefined → no icon
            if (repeatOption === "0") return Images.TimeIcon;

            return Images.RepeatEventClock;          // repeat clock icon
        }, [repeatOption]);

        /* -------------------- ACTION BUTTONS -------------------- */

        // Shared by renderActionButtons and the button count, so the two cannot drift.
        const showCheckOutButton =
            !isCheckIn && showCheckOut && spotId >= 0 &&
            Array.isArray(checkInType) && checkInType.length > 0 && checkInFlag === 1;
        const showSpaceTakenButton = showLeaveQueue === false && showReportLabel === 1;
        const showGoToMapButton = mapAvailable === 1 && mapAvailableType !== 1;

        // EditMeetingButtons renders 1 button, or 3 for a series (meetingRepeat > 0):
        // this event, all events in the series, this and all following events (RON-5834).
        const editMeetingButtonCount = showRescheduleButton ? (meetingRepeat > 0 ? 3 : 1) : 0;
        const actionButtonCount =
            [isCheckIn, showCheckOutButton, showSpaceTakenButton, showGoToMapButton,
                showDeclineButton, showCancelButton === true]
                .filter(Boolean).length + editMeetingButtonCount;

        const renderActionButtons = () => {
            ////console.log("mapAvailable,  mapAvailableType,  bookingForModal?.DeskAvailable ,  bookingForModal?.MeetingRoomAvailable, zoneCreditValue, individualDayCost ===",
            //    mapAvailable, mapAvailableType, bookingForModal?.DeskAvailable, bookingForModal?.MeetingRoomAvailable, zoneCreditValue, individualDayCost);
            ////console.log("showReportLabel,showLeaveQueue at renderActionButtons->", showReportLabel, showLeaveQueue);

            //if (!bookingForModal) return null;
            //console.log("Post Event Modal Testing")
            ////console.log("meetingRoomAvailable of posteventmodal-", meetingRoomAvailable)
            return (
                <>
                    {/* Check In Button */}
                    {/* Only for Today's Booking - After booking conditions */}
                    {isCheckIn && (
                        <CheckInButton zoneId={zoneId} bookingDateStr={bookingDateStr} checkInFlag={1} CheckInDate={getCurrentDateTime()} spotId={spotId} />
                    )}
                    {/* Check Out Button */}
                    {showCheckOutButton && (
                        <CheckOutButton zoneId={zoneId} bookingDateStr={bookingDateStr} checkInFlag={2} CheckInDate={getCurrentDateTime()} spotId={spotId} />
                    )}
                    {/* Space taken button*/}
                    {showSpaceTakenButton && (
                        <SpotTakenButton zoneId={zoneId} bookingDateStr={bookingDateStr} isLoading={isLoading} />
                    )}
                    {/* GoTo Map Button */}
                    {showGoToMapButton && (
                        <GoToMapButton zoneId={zoneId} bookingDateStr={formatDate(bookingDateStr)} />
                    )}
                    {/*Decline Button*/}
                    {showDeclineButton && (
                        <DeclineButton zoneId={zoneId} bookingDateStr={bookingDateStr} isLoading={isLoading} BookingId={meetingId} />
                    )}
                    {/*Edit meeting buttons (RON-5375) - replaces the old single Reschedule button */}
                    {showRescheduleButton && (
                        <EditMeetingButtons meetingRepeat={meetingRepeat} />
                    )}
                    {/*Cancel Booking Button */}    {/*SHOW Cancel Booking when condition is FALSE */}
                    {showCancelButton === true && (
                        <CancelBookingButton zoneId={zoneId} bookingDateStr={bookingDateStr} meetingId={meetingId} />
                    )}

                </>
            );
        }
        /* -------------------- JSX -------------------- */

        return (
            <div>
                <div
                    className={`modal ctm-modalscroll-modal${actionButtonCount > 3 ? " ctm-space-modal" : ""}`}
                    style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    id="dateModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="ctm-modal-header">
                                    <div className="close-modal">
                                        <a onClick={onClose}>
                                            <img src={Images.Close} aria-label="Close" />
                                        </a>
                                    </div>

                                    <div className="pt-4">
                                        <h5 className="popup-title">{titleText}</h5>
                                    </div>

                                    <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                        <div className="selected-current-date">
                                            <span>{selectedDay}</span>
                                            <span>{t(displayMonth)} {displayYear}</span>
                                        </div>
                                        {/* Show CREDIT */}
                                        {zoneCreditValue > 0 && (
                                            <div className="credit-info">
                                                <a
                                                    href="#"
                                                    className="orange-outline-with-icon"
                                                    onClick={(e) => e.preventDefault()}
                                                >
                                                    {isZeroDisplayCredit ? (
                                                        <>
                                                            <img src={Images.GrayStar} alt="star" className="img-fluid" />
                                                            <span>{displayCreditValue}</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <img src={Images.OrangeStar} alt="star" className="img-fluid" />
                                                            <span>
                                                                {`+${displayCreditValue}`}
                                                            </span>
                                                        </>
                                                    )}
                                                </a>
                                            </div>
                                        )}

                                    </div>

                                    <div className="divider-line mt-3"></div>
                                </div>
                                <div className="modal-des">
                                    <div className="modal-scroll-inner">
                                        <div className="icon-with-list">
                                            {(hasBookingDate && totalBookings > 0) && (
                                                <>
                                                    {/* Zone name */}
                                                    <div className="icon-wrap">
                                                        <img src={Images.ZoneMap} alt="map" />
                                                        <h4>{zoneName}</h4>
                                                    </div>

                                                    {/* Hourly booking */}
                                                    {isHourlyBooking ? (
                                                        <>
                                                            {/* Start & End time exists */}
                                                            {hasTime ? (
                                                                <>
                                                                    <div className="icon-wrap">
                                                                        {repeatIcon && <img src={repeatIcon} alt="repeat" />}
                                                                        <h4>
                                                                            {eventStartTime} - {eventEndTime},{" "}
                                                                            <span>{formatDateToEEEddMMM(bookingDateStr)}</span>
                                                                        </h4>
                                                                    </div>

                                                                    {/* Meeting details only for SpotType === 3 */}
                                                                    {spotType === 3 && (
                                                                        <div className="icon-wrap meeting-icon">
                                                                            <h4 className="ps-3 ms-3">
                                                                                {meetingName} <span>({organiserName})</span>
                                                                            </h4>
                                                                        </div>
                                                                    )}
                                                                </>
                                                            ) : hasNoTime ? (
                                                                /* No start/end time */
                                                                <div className="icon-wrap">
                                                                    {repeatIcon && <img src={repeatIcon} alt="repeat" />}
                                                                    <h4>{formatDateToEEEddMMM(bookingDateStr)}</h4>
                                                                </div>
                                                            ) : null}
                                                        </>
                                                    ) : (
                                                        /* All day booking */
                                                        <div className="icon-wrap">
                                                            {repeatIcon && <img src={repeatIcon} alt="repeat" />}
                                                            <h4 className="ps-3 ms-3">
                                                                {t("react_all_day")} <span>{formatDateToEEEddMMM(bookingDateStr)}</span>
                                                            </h4>
                                                        </div>
                                                    )}
                                                </>
                                            )}
                                            {/* {!meetingName && ( */}
                                            <div className="icon-wrap">
                                                <img src={Images.Participant} />
                                                <h4>{UserName}</h4>
                                            </div>
                                            {/* )} */}

                                        </div>
                                        {spotTagList && (
                                            <div >
                                                <SpotTags spotTagList={spotTagList} />
                                            </div>
                                        )
                                        }
                                    </div>
                                </div>
                                <div className="ctm-modal-footer">
                                    {renderActionButtons()}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    const AlldayPreEventModal = ({ onClose, zoneId }) => {
        const { bookingDateStr, bookingForModal } = useBookingContext(clickedFullDay, weekData);
        const { displayMonth, displayYear } = useBookingDisplayDate(clickedFullDay, setSelectedDay);

        /* -------------------- VEHICLE DROPDOWN -------------------- */

        const vehicleList = useMemo(() => {
            if (!bookingForModal?.EmployeeVehicleType) return [];

            return bookingForModal.EmployeeVehicleType.map(v => ({
                VehicleId: String(v.VehiclePrimaryKey),
                VehicleLabel: String(v.VehicleRegistrationId),
            }));
        }, [bookingForModal?.EmployeeVehicleType]);

        const isRandomSpaceDisabled = Boolean(preBookingQuestion) && !checkedPreBookingQue;
        const isJoinQueueDisabled = Boolean(preBookingQuestion) && !checkedPreBookingQue;

        // true when the selected date already has an all-day parking (1) or desk/room (2) booking
        const isAllDaySpotBooked = useMemo(
            () => (bookingForModal?.Bookings || []).some(
                b => (b.SpotType === 1 || b.SpotType === 2) && b.BookingPeriod === 1
            ),
            [bookingForModal?.Bookings]
        );

        let titleText = `${t("react_calendar_new_booking")}`;

        if (displayQueue === 1) {
            titleText = `${t("react_no_space_left")}`;
        }

        const safeHtml = DOMPurify
            .sanitize(preBookingQuestion)
            .replace(/<a /g, '<a target="_blank" rel="noopener noreferrer" ');
        useEffect(() => {
            if (!vehicleId || !bookingForModal?.EmployeeVehicleType) return;

            const vehicle = bookingForModal.EmployeeVehicleType.find(
                v => String(v.VehiclePrimaryKey) === String(vehicleId));

            setSelectedVehicle(vehicle || null);
        }, [vehicleId, bookingForModal?.EmployeeVehicleType]);

        useEffect(() => {
            if (!vehicleList.length) return;
            setVehicleId(prev => prev || vehicleList[0].VehicleId);
        }, [vehicleList]);

        /* -------------------- ACTION BUTTONS -------------------- */

        const renderActionButtons = () => {

            if (!bookingForModal) return null;
            //console.log("Allday Pre EventModal Testing");
            return (
                <>
                    {/* GoTo Map Button */}
                    {(mapAvailable === 1 && mapAvailableType !== 1) && (
                        <GoToMapButton zoneId={zoneId} bookingDateStr={bookingDateStr} />
                    )}
                    {/* Random Space Button */}
                    {/* deskAvailable === 1 &&     displayQueue === 0 &&    spotAvailable === 1 && */}
                    {/* ((spotAvailable === 1 && deskAvailable === 1) && (isBookingBlocked != 1)) && ( */}
                    {/* {(spotAvailable === 1 && deskAvailable === 1 && isBookingBlocked !== 1) && ( */}
                    {/* {(spotAvailable === 1 && isBookingBlocked !== 1) && ( */}
                    {(spotAvailable === 1 && deskAvailable === 1 && !isAllDaySpotBooked) && (
                        <RandomSpaceButton
                            zoneId={zoneId}
                            bookingDateStr={bookingDateStr}
                            disabled={isRandomSpaceDisabled}
                        />
                    )}
                    {/* {(deskAvailable === 1 && displayQueue === 0 && spotAvailable === 1) && (
                        <RandomSpaceButton zoneId={zoneId} bookingDateStr={bookingDateStr}
                            disabled={isRandomSpaceDisabled} />
                    )} */}
                    {/* Join the waitlist button*/}
                    {displayQueue === 1 && isAllDayContext === true && (
                        <JoinQueueButton zoneId={zoneId} bookingDateStr={bookingDateStr}
                            disabled={isJoinQueueDisabled} />
                    )}
                </>
            );
        }
        /* -------------------- JSX -------------------- */

        return (
            <div>
                <div
                    className="modal ctm-modalscroll-modal"
                    style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                    id="dateModal"
                    data-bs-backdrop="static"
                    data-bs-keyboard="false"
                >
                    <div className="modal-dialog modal-dialog-centered modal-custom-width">
                        <div className="modal-content modal-radius">
                            <div className="modal-body">
                                <div className="ctm-modal-header">
                                    <div className="close-modal">
                                        <a onClick={onClose}>
                                            <img src={Images.Close} aria-label="Close" />
                                        </a>
                                    </div>

                                    <div className="pt-4">
                                        <h5 className="popup-title">{titleText}</h5>
                                    </div>

                                    <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                        <div className="selected-current-date">
                                            <span>{selectedDay}</span>
                                            <span>{t(displayMonth)} {displayYear}</span>
                                        </div>
                                        {/* Show CREDIT */}
                                        {zoneCreditValue > 0 && (
                                            <div className="credit-info">
                                                <a
                                                    href="#"
                                                    className="orange-outline-with-icon"
                                                    onClick={(e) => e.preventDefault()}
                                                >
                                                    {individualDayCost === 0 || individualDayCost === "0" ? (
                                                        <>
                                                            <img src={Images.GrayStar} alt="star" />
                                                            <span>{individualDayCost}</span>
                                                        </>
                                                    ) : (
                                                        <>
                                                            <img src={Images.OrangeStar} alt="star" />
                                                            <span>
                                                                {isExistingEvent === false && (`-${individualDayCost}`)}
                                                            </span>
                                                        </>
                                                    )}
                                                </a>
                                            </div>
                                        )}
                                    </div>

                                    <div className="divider-line mt-3"></div>
                                </div>
                                <div className="modal-des">
                                    <div className="modal-scroll-inner">
                                        <div className="booking-name d-flex align-items-center gap-2">
                                            <img src={Images.Participant} />
                                            <h4>{UserName}</h4>
                                        </div>

                                        {/* {(zoneType == 1 && bookingForModal?.DeskAvailable === 1 && spotAvailable === 1) && */}
                                        {((zoneType == 1 && bookingForModal?.DeskAvailable === 1 && spotAvailable === 1)
                                            || (displayQueue === 1 && isAllDayContext === true && zoneType === 1))   /* TASK: RON-5482 For Join Queue Button in Parking and Desk Booking */
                                            &&
                                            (vehicleList.length > 0 && (
                                                <div className="custom-dropdown modal-dropdown mb-3">
                                                    <CustomSearchableDropdown
                                                        items={vehicleList}
                                                        value={vehicleId}
                                                        labelKey="VehicleLabel"
                                                        valueKey="VehicleId"
                                                        searchable={false}
                                                        disabled={!vehicleList.length}
                                                        onChange={setVehicleId}
                                                    />
                                                </div>
                                            ))
                                        }
                                        <div className="participants-list ctm-checklist">
                                            {!!preBookingQuestion && (
                                                <div className={`form-check ${checkedPreBookingQue ? "check-active" : ""
                                                    }`}>
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id={`preBookingQuestion`}
                                                        checked={checkedPreBookingQue}
                                                        onChange={(e) => setCheckedPreBookingQue(e.target.checked)}
                                                    />

                                                    <label
                                                        className="form-check-label ms-2"
                                                        htmlFor={`preBookingQuestion`}
                                                    >
                                                        <span dangerouslySetInnerHTML={{ __html: safeHtml }} />

                                                    </label>
                                                </div>
                                            )}
                                        </div>

                                        <div className="text-center my-34">
                                            {zoneType === 1 ? (
                                                <img src={Images.ParkingBooking} className="img-fluid" alt="Parking Booking" />
                                            ) : zoneType === 2 && meetingRoomAvailable === 1 && bookingForModal?.HourlySpotAvailable === 0 && bookingForModal?.DeskAvailable === 0 ? (
                                                <img src={Images.Meeting} className="img-fluid" alt="Meeting" />
                                            ) : zoneType === 2 ? (
                                                <img src={Images.Deskbooking} className="img-fluid" alt="Desk Booking" />
                                            ) : null}
                                        </div>
                                    </div>
                                </div>

                                <div className="ctm-modal-footer">
                                    {renderActionButtons()}
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    };
    const AlldayPostEventModal = ({ onClose, zoneId, event }) => {

        //console.log("AlldayPostEventModal mounted, event =", event);

        const safeEvent = event ?? {};

        const {
            extendedProps = {},
            startStr = "",
            allDay = false
        } = safeEvent;

        const bookingDateStr = startStr;

        // ✅ Hook is ALWAYS called
        const { displayMonth, displayYear } =
            useBookingDisplayDate(bookingDateStr, setSelectedDay);

        const {
            spotTagList,
            spotId,
            spotType,
            checkInFlag,
            checkInType,
            bookingPeriod,
            repeatOption,
            StartTime: eventStartTime,
            EndTime: eventEndTime,
            meetingName,
            organiserName,
            showReportLabel,
            spotName,
            organiserId,
            userId,
            isApproversExist,
            meetingApproveStatus,
            isApprover,
            //showLeaveQueue,
            queuePosition,
            //zoneType,
            zoneCurrentDateTime,
            fullRefundCredit,
            halfRefundCredit,
            noRefundCredit,
            refundStartDateTime,
            refundEndDateTime,


        } = extendedProps;
        console.log("extendedProps of AlldayPostEventModal - ", extendedProps);
        //console.log("event.extendedProps.spotId of AlldayPostEventModal - ", event.extendedProps.spotId);
        ////console.log("SpotId of AlldayPostEventModal - ", spotId);

        ////console.log("deskAvailable of AlldayPostEventModal - ", deskAvailable);
        ////console.log("spotId,spotType,bookingPeriod,joinedQueue,queuePosition,spotName,organiserId,userId,isApproversExist,meetingApproveStatus,isApprover,showReportLabel,checkInFlag,checkInType,repeatOption,eventStartTime,eventEndTime--",
        //spotId, spotType, bookingPeriod, joinedQueue, queuePosition, spotName, organiserId, userId, isApproversExist, meetingApproveStatus, isApprover, showReportLabel, checkInFlag, checkInType, repeatOption, eventStartTime, eventEndTime)

        const hasBookingDate = Boolean(bookingDateStr);
        const displayCreditValue = getDisplayRefundCreditValue({
            refundStartDateTime,
            refundEndDateTime,
            zoneCurrentDateTime,
            fullRefundCredit,
            halfRefundCredit,
            noRefundCredit
        });
        console.log("displayCreditValue of AlldayPostEventModal - ", displayCreditValue);
        const isZeroDisplayCredit =
            displayCreditValue === 0 || displayCreditValue === "0";

        const isHourlyBooking = spotType === 3 || bookingPeriod === 2;

        const hasTime = eventStartTime && eventEndTime;
        const hasNoTime = !eventStartTime && !eventEndTime;

        const showLeaveQueue = ((zoneType === 1 && spotType === 1) || (zoneType === 2 && spotType === 2))
            && (bookingPeriod === 1 && joinedQueue === 1);
        console.log("zoneType,spotType,bookingPeriod,joinedQueue--->", zoneType, spotType, bookingPeriod, joinedQueue);
        console.log("showLeaveQueue--->", showLeaveQueue);
        const isCheckIn = (checkInType.length > 0 && (checkInType.includes(2)) && spotId >= 0 && (checkInFlag === 0 || checkInFlag === 2));
        const showCheckOut = checkInType.includes(0) ? false : true;
        const isSpotType3 = spotType === 3;
        const isOrganiserEqualUser = organiserId === userId;
        const hasApprovers = isApproversExist === 1;

        const canRescheduleByApproval =
            meetingApproveStatus === 0 ||
            meetingApproveStatus === 5 ||
            (isApprover === 1 && meetingApproveStatus === 1);
        let showCancelButton = true;

        let showRescheduleButton = false;
        let showDeclineButton = false;

        if (hasNoTime) { showCancelButton = true; }   // if there is All day booking then Cancel button should display
        //if (totalBookings > 0) { showCancelButton = true; }
        if (showLeaveQueue) { showCancelButton = false; }

        if (isSpotType3) {

            if (!isOrganiserEqualUser) {         // OrganiserId != UserId

                showCancelButton = false;
                showRescheduleButton = false;
                showDeclineButton = true;

            } else {                            // OrganiserId == UserId

                showDeclineButton = false;
                showCancelButton = true;

                if (hasApprovers) {
                    showRescheduleButton = canRescheduleByApproval;
                } else {
                    showRescheduleButton = true;
                }
            }
        }

        ////console.log("totalBookings--->", totalBookings);
        ////console.log("showCancelButton-->", showCancelButton);

        let titleText = "";
        if (showLeaveQueue) {
            if (queuePosition === 0)
                titleText = t("react_you_are_on_waitlist");
            else {
                titleText = formatReactString(t("react_waiting_position"), [queuePosition], {
                    defaultRenderer: (val) => (
                        <span className="color-dark-black">{queuePosition}</span>
                    )
                });
            }
        }
        else if (!showLeaveQueue || (zoneType === 2 && spotType === 3 && !isOrganiserEqualUser)) {
            titleText = formatReactString(t("YourBookingForSpace"), [spotName], {
                defaultRenderer: (val) => (
                    <span className="color-dark-black">{spotName}</span>
                )
            });
        }
        else if (zoneType === 2 && spotType === 3 && isOrganiserEqualUser) {
            titleText = formatReactString(t("react_invited_for"), [spotName], {
                defaultRenderer: (val) => (
                    <span className="color-dark-black">{spotName}</span>
                )
            });
        }
        else {
            titleText = formatReactString(t("YourBookingForSpace"), [spotName], {
                defaultRenderer: (val) => (
                    <span className="color-dark-black">{spotName}</span>
                )
            });
        }

        const repeatIcon = useMemo(() => {
            if (!repeatOption) return null;          // "" or undefined → no icon
            if (repeatOption === "0") return Images.TimeIcon;

            return Images.RepeatEventClock;          // repeat clock icon
        }, [repeatOption]);

        /* -------------------- ACTION BUTTONS -------------------- */

        const renderActionButtons = () => {
            //    mapAvailable, mapAvailableType, bookingForModal?.DeskAvailable, bookingForModal?.MeetingRoomAvailable, zoneCreditValue, individualDayCost);
            ////console.log("showReportLabel,showLeaveQueue at renderActionButtons->", showReportLabel, showLeaveQueue);
            ////console.log("AlldayPostEventModal Testing")
            ////console.log("meetingRoomAvailable of AlldayPostEventModal-", meetingRoomAvailable)
            return (
                <>
                    {/* Check In Button */}
                    {/* Only for Today's Booking - After booking conditions */}
                    {isCheckIn && (
                        <CheckInButton zoneId={zoneId} bookingDateStr={bookingDateStr} checkInFlag={1} CheckInDate={getCurrentDateTime()} spotId={spotId} />
                    )}
                    {/* Check Out Button */}
                    {(!isCheckIn && (showCheckOut && spotId >= 0 && (Array.isArray(checkInType) && checkInType.length > 0) && checkInFlag === 1)) && (
                        <CheckOutButton zoneId={zoneId} bookingDateStr={bookingDateStr} checkInFlag={2} CheckInDate={getCurrentDateTime()} spotId={spotId} />
                    )}
                    {/* Space taken button*/}
                    {(showLeaveQueue === false && showReportLabel === 1) && (
                        <SpotTakenButton zoneId={zoneId} bookingDateStr={bookingDateStr} isLoading={isLoading} />
                    )}
                    {/* GoTo Map Button */}
                    {(mapAvailable === 1 && mapAvailableType !== 1) && (
                        <GoToMapButton zoneId={zoneId} bookingDateStr={bookingDateStr} />
                    )}
                    {/* Leave the waitlist button*/}    {/* Parking = zoneType === 1, Desk-booking = zoneType === 2 */}
                    {showLeaveQueue && (
                        <LeaveQueButton zoneId={zoneId} bookingDateStr={bookingDateStr} isLoading={isLoading} spotId={spotId} />
                    )}
                    {/*Cancel Booking Button */}    {/*SHOW Cancel Booking when condition is FALSE */}
                    {showCancelButton === true && (
                        <CancelBookingButton zoneId={zoneId} bookingDateStr={bookingDateStr} isLoading={isLoading} />
                    )}

                </>
            );
        }
        /* -------------------- JSX -------------------- */

        return (

            <div
                className="modal ctm-modalscroll-modal ctm-space-modal"
                style={{ display: "block", backgroundColor: "rgba(217, 217, 217, 0.59)" }}
                id="dateModal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
            >
                <div className="modal-dialog modal-dialog-centered modal-custom-width">
                    <div className="modal-content modal-radius">
                        <div className="modal-body">
                            <div className="ctm-modal-header">
                                <div className="close-modal">
                                    <a onClick={onClose}>
                                        <img src={Images.Close} aria-label="Close" />
                                    </a>
                                </div>

                                <div className="pt-4">
                                    <h5 className="popup-title">{titleText}</h5>
                                </div>

                                <div className="date-with-credit d-flex align-items-center justify-content-between pt-2">
                                    <div className="selected-current-date">
                                        <span>{selectedDay}</span>
                                        <span>{t(displayMonth)} {displayYear}</span>
                                    </div>
                                    {/* Show CREDIT */}
                                    {zoneCreditValue > 0 && (
                                        <div className="credit-info">
                                            <a
                                                href="#"
                                                className="orange-outline-with-icon"
                                                onClick={(e) => e.preventDefault()}
                                            >
                                                {isZeroDisplayCredit ? (
                                                    <>
                                                        <img src={Images.GrayStar} alt="star" className="img-fluid" />
                                                        <span>{displayCreditValue}</span>
                                                    </>
                                                ) : (
                                                    <>
                                                        <img src={Images.OrangeStar} alt="star" className="img-fluid" />
                                                        <span>
                                                            {`+${displayCreditValue}`}
                                                        </span>
                                                    </>
                                                )}
                                            </a>
                                        </div>
                                    )}
                                </div>

                                <div className="divider-line mt-3"></div>
                            </div>
                            <div className="modal-des">
                                <div className="modal-scroll-inner">
                                    <div className="icon-with-list">
                                        {/* Zone name */}
                                        <div className="icon-wrap">
                                            <img src={Images.ZoneMap} alt="map" />
                                            <h4 className="ps-1 ms-1">{zoneName}</h4>
                                        </div>
                                        {/* All day booking  */}
                                        <div className="icon-wrap">
                                            {repeatIcon && <img src={repeatIcon} alt="repeat" />}
                                            <h4 className="ps-1 ms-1">
                                                {t("all_day")} <span>{formatDateToEEEddMMM(bookingDateStr)}</span>
                                            </h4>
                                        </div>
                                        <div className="icon-wrap">
                                            <img src={Images.Participant} />
                                            <h4 className="ps-1 ms-1">{UserName}</h4>
                                        </div>
                                        {/*  <div className="text-center my-34">
                                    {zoneType === 1 ? (
                                        <img src={Images.ParkingBooking} className="img-fluid" alt="Parking Booking" />
                                    ) : zoneType === 2 && meetingRoomAvailable === 1 && isHourlyBooking && deskAvailable === 0 ? (
                                        <img src={Images.Meeting} className="img-fluid" alt="Meeting" />
                                    ) : zoneType === 2 ? (
                                        <img src={Images.Deskbooking} className="img-fluid" alt="Desk Booking" />
                                    ) : null}
                                </div> */}




                                    </div>
                                    {spotTagList && (
                                        <div>
                                            <SpotTags spotTagList={spotTagList} />
                                        </div>
                                    )
                                    }
                                </div>
                            </div>
                            <div className="ctm-modal-footer">
                                {renderActionButtons()}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );
    };

    const resetValues = () => {
        setCheckedPreBookingQue(false);
        setPreBookingQuestion("");
        setVehicleId("");
        setSelectedVehicle(null);

        setDeskAvailable(0);
        setIsBookingBlocked(0);
        setDisplayQueue(0);
        setMeetingRoomAvailable(0);
        setHourlySpotAvailable(0);
        setIndividualDayCost(0);
        setJoinedQueue(0);
        setQueuePosition(0);
        setShowWaitlistPosition(0);
        setEmployeeQueueCount(0);
        setTotalBookings(0);
        setSpotTagList([]);
        setSpotId(0);
        setSpotType(null);
        setCheckInFlag(0);
        setCheckInType([]);
        setBookingPeriod(0);
        setRepeatOption("0");
        setEventStartTime("");
        setEventEndTime("");
        setMeetingId(0);
        setMeetingName("");
        setOrganiserName("");
        setShowReportLabel("");
        setSpotName("");
        setOrganiserId(0);
        setUserId(0);
        setIsApproversExist(0);
        setMeetingApproveStatus(0);
        setIsApprover(0);
        setClickedFullDay(null);
        setSelectedBookingDate(null);
        //setPostbookingQueModalData([]);
        setParkingViolationReportingData(null);
        setShowPreEventModal(false);
        setShowPostEventModal(false);
        setShowAlldayPreEventModal(false);
        setShowAlldayPostEventModal(false);

        setShowCancelConfirm(false);
        setShowReportParkingViolationModal(false);
        setShowAlternateParkingSpotModal(false);
        //setShowPostbookingQueModal(false);
        setIsLoading(false);
    };

    function GotoMapClick(zoneId, bookingDateStr) {
        if (mapAvailableType === 2 || mapAvailableType === 3) {

            history.push("/map", {
                selectedZoneId: zoneId,
                selectedDate: bookingDateStr
            });

        } else {
            history.push("/no-map-available", { zoneId });
        }

    }

    const GetRandomSpace = async (zoneId, bookingDateStr) => {
        if (isLoading) return;
        setIsLoading(true);
        try {
            setLoadingDates(prev => [...prev, bookingDateStr]);

            const reqParams = {
                ZoneId: zoneId,
                BookingDate: bookingDateStr,

                // FROM SELECTED VEHICLE
                VehicleTypeId: selectedVehicle ? selectedVehicle.Id : 0,
                VehicleFuelId: selectedVehicle ? selectedVehicle.FuelId : 0,
                VehicleShareableId: selectedVehicle ? selectedVehicle.ShareableId : 0,
                VehicleAccessibleId: selectedVehicle ? selectedVehicle.AccessibleId : 0,
                CarRegistrationNumber: selectedVehicle ? selectedVehicle.VehicleRegistrationId : "",
            };
            //console.log("GetRandomSpace() - ReqParams:", reqParams);

            const response = await MakeBooking_api(reqParams);
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 1,
                alertPopup: 1
            });
            //console.log("MakeBooking_api() - response -- ", response);
            //const result = handleResponseCode(response);
            if (response?.Data?.ResponseCode === 200) {
                //if (result.success || (response && result.code === 200)) {
                ////console.log("formatDate( selectedDate) -->", formatDate(selectedDate))
                const bookingStatusreqParams = {
                    ZoneId: zoneId,
                    BookingQueueId: response?.Data?.Records?.BookingQueueId,
                    RequestedBookingDate: bookingDateStr,
                    IsGuest: 0,    // ONLY for WEEKLY

                    // FROM SELECTED VEHICLE
                    VehicleTypeId: selectedVehicle ? selectedVehicle.Id : 0,
                    VehicleFuelId: selectedVehicle ? selectedVehicle.FuelId : 0,
                    VehicleShareableId: selectedVehicle ? selectedVehicle.ShareableId : 0,
                    VehicleAccessibleId: selectedVehicle ? selectedVehicle.AccessibleId : 0
                };
                const statusResult = await pullBookingStatus(bookingStatusreqParams);
                //console.log("statusResult from getrandomspace", statusResult);

                if (!statusResult?.stopFetch) {
                    await refreshBookingsForRequestedDate(zoneId, formatDate(bookingDateStr));
                }

            } else {
                console.error("MakeBooking_api() failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling GetRandomSpace:", error);
        } finally {
            setCheckedPreBookingQue(false);
            setShowAlldayPreEventModal(false)
            resetValues();
            setLoadingDates(prev => prev.filter(d => d !== bookingDateStr));
            setIsLoading(false);
        }
    };

    const pullBookingStatus = async (reqParams) => {

        const maxAttempts = 3;

        for (let attempt = 1; attempt <= maxAttempts; attempt++) {

            // 3s before every retry, whatever ended the previous attempt
            // (still processing, no spot yet, or a failed request).
            if (attempt > 1) {
                await new Promise(res => setTimeout(res, 3000));
            }

            try {


                reqParams.TeamMemberGuId = ""
                const response = await BookingStatus_api(reqParams);
                //const result = handleResponseCode(response);

                const records = response?.Data?.Records || {};
                const spotId = records?.SpotId ?? null;
                const isPastBooking = records?.IsPastBooking ?? 0;
                const errorCode = response?.Data?.ResponseCode;
                /* handleApiResponse(response, setNotification, t, {
                    successMsg: 1,
                    errorMsg: 1
                }); */
                handleApiUiResponse(response, {
                    successToaster: 1,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        603: async () => {
                            if (!selectedZoneId || !reqParams?.RequestedBookingDate) return;
                            await refreshBookingsForRequestedDate(selectedZoneId, reqParams.RequestedBookingDate);
                        },
                        602: async () => {
                            if (!selectedZoneId || !reqParams?.RequestedBookingDate) return;
                            await refreshBookingsForRequestedDate(selectedZoneId, reqParams.RequestedBookingDate);
                        },
                        606: async () => {
                            if (!selectedZoneId || !reqParams?.RequestedBookingDate) return;
                            await refreshBookingsForRequestedDate(selectedZoneId, reqParams.RequestedBookingDate);
                        }
                    }
                });

                if (errorCode === 423) {
                    localStorage.clear();
                    sessionStorage.clear();
                    history.push("/login", { replace: true });
                    return { stopFetch: true };
                }

                // if (errorCode === 416 || errorCode === 427 || errorCode === 605) {
                //     return { stopFetch: true };
                // }

                if (errorCode !== 200 && errorCode !== 1555) {
                    return { stopFetch: true };
                }

                if (toSafeFloat(spotId) === -1) {
                    // Still processing: check again on the next attempt.
                    continue;
                }

                if (toSafeFloat(spotId) > 0) {
                    await refreshBookingsForRequestedDate(selectedZoneId, formatDate(reqParams.RequestedBookingDate));
                    if (Number(isPastBooking) === 1) {
                        const res = await PostBookingQuestion_api({
                            ZoneId: reqParams.ZoneId
                        });

                        if (res?.Data?.ResponseCode === 200) {
                            const questions =
                                res?.Data?.Records?.QuestionAnswerList || [];
                            //console.log("questions from pullbookingstatus", questions)
                            setPostRequestParams({
                                ZoneId: selectedZoneId,
                                ClaimDate: reqParams.ClaimDate || getBookingDateStr(selectedBookingDate),
                                StartTime: "",
                                EndTime: "",
                                SpotId: spotId,
                                ClaimId: response?.Data?.Records?.LastId_tblparkingrelease,
                                CompanyId: res?.Data?.Records?.CompanyId,
                                IsGuest: 0,     //  ONLY for WEEKLY
                            });
                            setPostbookingQueModalData(questions);

                            setShowAlldayPostEventModal(false);

                            setShowPostbookingQueModal(true);  // ✅ OPEN MODAL HERE

                            return { stopFetch: true };
                        }

                    }

                    return { stopFetch: true };
                }

            } catch (error) {
                console.error("BookingStatus_api error:", error);
            }
        }

        return { stopFetch: false };
    };

    async function CancelBooking(zoneId, bookingDateStr, cancelBookingSpotId) {
        /* console.log(
            `Cancel Booking Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, SpotId=${cancelBookingSpotId}`
        ); */
        try {
            if (isLoading) return;
            setIsLoading(true);
            setLoadingDates((prev) => [...prev, bookingDateStr]);
            //const response = await CancelBooking_api(zoneId, bookingDateStr, cancelBookingSpotId);
            const reqParams = {
                BookingDate: bookingDateStr,
                SpotId: cancelBookingSpotId,
                ZoneId: zoneId,
                IsGuest: 0,
            };

            const response = await CancelBooking_api(reqParams);


            if (response && response.Data?.ResponseCode === 200) {
                setShowCancelConfirm(false);
                setShowAlldayPostEventModal(false);
                handleApiUiResponse(response, {
                    successToaster: 1,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        607: async () => {
                            if (!zoneId || !bookingDateStr) return;
                            await refreshBookingsForRequestedDate(zoneId, bookingDateStr);
                        },
                    }
                });

                await delay(800);
                await fetchBookings(zoneId, getVisibleWeekStartDateString(selectedDate));
                resetValues();
            } else {
                handleApiUiResponse(response, {
                    successToaster: 1,
                    errorToaster: 1,
                    alertPopup: 1,
                    onConfirmByCode: {
                        607: async () => {
                            if (!zoneId || !bookingDateStr) return;
                            await refreshBookingsForRequestedDate(zoneId, bookingDateStr);
                        },
                    }
                });
                console.error("Cancel booking failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelBooking_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setIsLoading(false);
        }
    }
    async function CancelMeeting(zoneId, bookingDateStr, meetingId, CancelSelect, CancelDate) {
        /* //console.log(
            `Cancel Meeting Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, MeetingId=${meetingId}, CancelSelect=${CancelSelect} , CancelDate=${CancelDate}`
        ); */
        if (isLoading) return;
        setIsLoading(true);
        try {
            setLoadingDates((prev) => [...prev, bookingDateStr]);
            const reqParams = {
                BookingId: meetingId,
                CancelDate: CancelDate,
                CancelSelect: CancelSelect,
            };

            const response = await CancelMeeting_api(reqParams);
            //const result = handleResponseCode(response);
            /* handleApiResponse(response, setNotification, t, {
                successMsg: 1,
                errorMsg: 1
            }); */
            handleApiUiResponse(response, {
                successToaster: 1,
                errorToaster: 1,
                alertPopup: 1
            });
            if (response && response.Data?.ResponseCode === 200) {
                //if (result.success || (response && result.code === 200)) {
                setShowCancelMeetingDateSelectModal(false);
                setShowCancelMeetingModal(false);
                setShowPostEventModal(false);
                await delay(1000);
                await fetchBookings(zoneId, getVisibleWeekStartDateString(selectedDate));
                resetValues();
            } else {

                console.error("Cancel meeting failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling CancelMeeting_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setIsLoading(false);
        }
    }
    async function DeclineMeeting(zoneId, bookingDateStr, meetingId, DeclineSelect, DeclineDate) {
        /* console.log(
            `Decline Meeting Clicked: ZoneId=${zoneId}, BookingDate=${bookingDateStr}, MeetingId=${meetingId}`
        ); */
        if (isLoading) return;
        setIsLoading(true);
        try {
            setLoadingDates((prev) => [...prev, bookingDateStr]);
            const reqParams = {
                BookingId: meetingId,
                DeclineDate: DeclineDate,
                DeclineSelect: DeclineSelect,
            };

            const response = await DeclineMeeting_api(reqParams);
            /* handleApiResponse(response, setNotification, t, {
                successMsg: 1,
                errorMsg: 1
            }); */
            handleApiUiResponse(response, {
                successToaster: 1,
                errorToaster: 1,
                alertPopup: 1
            });
            if (response && response.Data?.ResponseCode === 200) {
                await delay(1000);
                await fetchBookings(zoneId, getVisibleWeekStartDateString(selectedDate));
                setShowDeclineMeetingDateSelectModal(false);
                setShowDeclineMeetingModal(false);
                setShowPostEventModal(false);
                resetValues();
            } else {
                /* setNotification({
                    type: "error",
                    title: "Error",
                    message: response?.Data?.ErrorMessage || "Something went wrong."
                }); */
                console.error("Decline meeting failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling DeclineMeeting_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setIsLoading(false);
        }
    }
    async function ParkingViolationReporting(zoneId, plateNoStr, spotIdStr, spotNameStr, bookingPeriodStr, bookingDateStr) {
        /* console.log(
            `ParkingViolationReporting Clicked: ZoneId=${zoneId}, SpotId=${spotIdStr}, SpotName=${spotNameStr}`
        ); */

        try {
            if (isLoading) return;
            setIsLoading(true);
            const spotViolationTypeStr = bookingPeriodStr === 2 ? 1 : 0;
            // RON-1840: the API rejects numeric ids here - Postman only succeeds
            // with strings, and a numeric payload comes back as a 500 with no CORS
            // headers, which the browser surfaces as a bare network failure.
            const reqParams = {
                ZoneId: String(zoneId ?? ""),
                PlateNo: plateNoStr,
                SpotViolationType: String(spotViolationTypeStr),
                SpotId: String(spotIdStr ?? ""),
                SpotName: spotNameStr,
                Tags: "",
            };

            const response = await ReportParkingViolation_api(reqParams);
            //console.log("ReportParkingViolation_api response:", response);
            /* handleApiResponse(response, setNotification, t, {
                successMsg: 1,
                errorMsg: 1
            }); */
            if (response && response.Data?.ResponseCode === 200) {
                //console.log("Parking violation reported successfully.", response.Data);
                setParkingViolationReportingData(response.Data);
                //console.log("ParkingViolationReportingData-->", parkingViolationReportingData);
                //resetValues();
                setShowReportParkingViolationModal(false);
                setShowAlternateParkingSpotModal(true);
            } else {
                /* setNotification({
                    type: "error",
                    title: "Error",
                    message: response?.Data?.ErrorMessage || "Something went wrong."
                }); */
                console.error("ReportParkingViolation_api failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling ReportParkingViolation_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setIsLoading(false);
        }
    }

    async function AlternateParkingSpotBooking(zoneId, bookingDateStr) {
        if (!parkingViolationReportingData) return;

        try {

            setIsLoading(true);
            setLoadingDates((prev) => [...prev, bookingDateStr]);
            // Alternate zone returned by ReportParkingViolation_api (RON-5587)
            const alternateZoneId = parkingViolationReportingData?.Records?.AlternateZoneId;
            const reqParams = {
                ViolatedSpotId: parkingViolationReportingData?.Records?.ViolatedSpotId,
                SpotId: parkingViolationReportingData?.Records?.SpotId,
                ZoneId: zoneId,
                AlternateZoneId: alternateZoneId,
                Tags: "0",
                BookingId: parkingViolationReportingData?.Records?.BookingId,
                StartTime: parkingViolationReportingData?.Records?.StartTime,
                EndTime: parkingViolationReportingData?.Records?.EndTime,
                NewBookingPeriod: parkingViolationReportingData?.Records?.NewBookingPeriod,
            };

            const response = await GetAlternateParkingSpot_api(reqParams);

            /* handleApiResponse(response, setNotification, t, {
                successMsg: 1,
                errorMsg: 1
            }); */
            handleApiUiResponse(response, {
                successToaster: 1,
                errorToaster: 1,
                alertPopup: 1
            });

            if (response && response.Data?.ResponseCode === 200) {
                //if (result.success || (response && result.code === 200)) {
                await delay(2000);
                // RON-5587: when the alternate zone differs, switch the zone dropdown to it.
                // Changing selectedZoneId triggers the effect that refreshes the calendar for
                // that zone, so no extra fetchBookings call is needed here.
                if (alternateZoneId && String(alternateZoneId) !== String(zoneId)) {
                    setSelectedZoneId(alternateZoneId);
                } else {
                    await fetchBookings(zoneId, getVisibleWeekStartDateString(selectedDate));
                }
                setShowAlternateParkingSpotModal(false);
                resetValues();
            } else {
                ////console.log("Error code received:", result.code);
                /* setNotification({
                    type: "error",
                    title: "Error",
                    message: response?.Data?.ErrorMessage || "Something went wrong."
                });
                console.error("AlternateParkingSpotBooking failed:", response?.Data?.ResponseMessage); */
            }
        } catch (error) {
            console.error("Error calling GetAlternateParkingSpot_api:", error);
        } finally {
            setLoadingDates((prev) => prev.filter((d) => d !== bookingDateStr));
            setIsLoading(false);
        }
    }

    const checkIncheckOut = async (CheckInFlag, zoneId, CheckInDate, spotId, bookingDateStr) => {
        try {

            setIsLoading(true);
            setLoadingDates(prev => [...prev, bookingDateStr]);

            const reqParams = {
                CheckInFlag: CheckInFlag,
                ZoneId: zoneId,
                CheckInDate: CheckInDate,
                SpotId: spotId,
            };

            //console.log("checkIncheckOut() - ReqParams:", reqParams);
            const response = await CheckInUser_api(reqParams);
            //console.log("CheckInUser_api() - response -- ", response);
            handleApiUiResponse(response, {
                successToaster: 0,
                errorToaster: 0,
                alertPopup: 1,
                onConfirmByCode: {
                    449: async () => {
                        if (!zoneId || !bookingDateStr) return;
                        await fetchBookings(zoneId, formatDate(bookingDateStr));
                    }
                }
            });
            if (response?.Data?.ResponseCode === 200) {
                ////console.log("formatDate( selectedDate) -->", formatDate(selectedDate))
                await delay(2000);
                await fetchBookings(zoneId, getVisibleWeekStartDateString(selectedDate));
            } else {
                /* setNotification({
                    type: "error",
                    title: "Error",
                    message: response?.Data?.ErrorMessage || "Something went wrong."
                }); */
                console.error("CheckInUser_api() failed:", response?.Data?.ResponseMessage);
            }
        } catch (error) {
            console.error("Error calling checkIncheckOut:", error);
        } finally {
            setShowPostEventModal(false);
            setShowAlldayPostEventModal(false);
            resetValues();
            setLoadingDates(prev => prev.filter(d => d !== bookingDateStr));
            setIsLoading(false);
        }
    };

    const handleHeaderCheckInCheckout = async (bookingRecord) => {
        if (!bookingRecord) return;

        const recordCheckInFlag = Number(bookingRecord.CheckInFlag);
        const actionCheckInFlag = recordCheckInFlag === 1 ? 2 : 1;
        const zoneId = selectedZoneId ?? bookingRecord.ZoneId;
        const bookingDateStr = formatDateYYYYMMDD(selectedDate);

        await checkIncheckOut(
            actionCheckInFlag,
            zoneId,
            getCurrentDateTime(),
            bookingRecord.SpotId,
            bookingDateStr
        );
    };

    ////console.log("showPostbookingQueModal:", showPostbookingQueModal);
    return (
        <div>
            <WeeklyCalendarUI
                isLoading={isLoading}
                recordsData={recordsData}
                events={events}
                onDatesSet={handleDatesSet}
                selectedDate={selectedDate}
                setSelectedDate={setSelectedDate}
                zones={zones}
                zoneDropdownOpen={zoneDropdownOpen}
                setZoneDropdownOpen={setZoneDropdownOpen}
                selectedZoneId={selectedZoneId}
                setSelectedZoneId={setSelectedZoneId}

                handleSlotAction={handleSlotAction}
                onEventClick={handleEventClick}
                holidays={holidays}
                onHeaderCheckInCheckout={handleHeaderCheckInCheckout}
                onCheckInCheckout={async (zoneId, bookingDateStr) => {
                    setIsLoading(true);
                    try {
                        await refreshBookingsForRequestedDate(
                            zoneId ?? selectedZoneId,
                            bookingDateStr ?? selectedDate
                        );
                    } finally {
                        setIsLoading(false);
                    }
                }}
                mapAvailable={mapAvailable}
            />
            {/* Time-grid New booking Modal */}
            {showPreEventModal && (
                <PreEventModal
                    onClose={() => {
                        resetValues();
                        setShowPreEventModal(false);
                    }}
                    zoneId={selectedZoneId}
                />
            )}
            {/* Time-grid Existing booking Modal */}
            {showPostEventModal && selectedEvent && (
                <PostEventModal
                    onClose={() => {
                        resetValues();
                        setShowPostEventModal(false);
                    }}
                    zoneId={selectedZoneId}
                    event={selectedEvent}
                />
            )}

            {/* Allday Event Modals */}
            {showAlldayPreEventModal && (
                <AlldayPreEventModal
                    onClose={() => {
                        resetValues();
                        setShowAlldayPreEventModal(false);
                    }}
                    zoneId={selectedZoneId}
                />
            )}
            {showAlldayPostEventModal && selectedEvent && (
                <AlldayPostEventModal
                    onClose={() => {
                        resetValues();
                        setShowAlldayPostEventModal(false);
                    }}
                    zoneId={selectedZoneId}
                    event={selectedEvent}
                />
            )}
            {/* Cancel All day & Hourly Bookings */}
            {showCancelConfirm && (
                <CancelBookingConfirmation
                    zoneId={selectedZoneId}
                    event={selectedEvent}
                    onClose={() => setShowCancelConfirm(false)}
                />
            )}

            {/* Cancel Meeting Modal */}
            {showCancelMeetingModal && (
                <CancelMeetingModal
                    zoneId={selectedZoneId}
                    event={selectedEvent}
                    onClose={() => setShowCancelMeetingModal(false)}
                />
            )}
            {showCancelMeetingDateSelectModal && (
                <CancelMeetingDateSelectModal
                    zoneId={selectedZoneId}
                    event={selectedEvent}
                    onClose={() => setShowCancelMeetingDateSelectModal(false)}
                />
            )}
            {/* Decline Meeting Modal */}
            {showDeclineMeetingModal && (
                <DeclineMeetingModal
                    zoneId={selectedZoneId}
                    event={selectedEvent}
                    onClose={() => setShowDeclineMeetingModal(false)}
                />
            )}
            {showDeclineMeetingDateSelectModal && (
                <DeclineMeetingDateSelectModal
                    zoneId={selectedZoneId}
                    event={selectedEvent}
                    onClose={() => setShowDeclineMeetingDateSelectModal(false)}
                />
            )}

            {/* Models belongs to Spot Taken */}
            {showReportParkingViolationModal && (
                <ReportParkingViolationModal
                    zoneId={selectedZoneId}
                    event={selectedEvent}
                    onClose={() => setShowReportParkingViolationModal(false)}
                />
            )}
            {showAlternateParkingSpotModal && (
                <AlternateParkingSpotModal
                    zoneId={selectedZoneId}
                    event={selectedEvent}
                    onClose={() => setShowAlternateParkingSpotModal(false)}

                />
            )}
            {/* Create New Meeting Modal */}
            {showScheduleMeetingModal && (
                <NewMeetingModal
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    show={true}
                    date={meetingModalDate}
                    // No startTime/endTime: NewMeetingModal now keeps a caller's time range
                    // on open (RON-5051), so these full-day placeholders would pre-select
                    // 00:00:00-23:59:59. Same as CalendarEvent / MapCanvasZone / MapGridZone.
                    // startTime="00:00:00"
                    // endTime="23:59:59"
                    selectedZone={selectedZoneId}
                    mapType={selectedZoneId ? (zoneMap[selectedZoneId] ?? 2) : undefined}
                    onClose={() => setShowScheduleMeetingModal(false)}
                    onConfirm={handleConfirm}
                    onMeetingCreated={() => {
                        setIsLoading(true);
                        fetchBookings(selectedZoneId, getVisibleWeekStartDateString(new Date()))
                        setIsLoading(false);
                    }}
                    setNotification={setNotification}
                    setShowScheduleMeetingModal={setShowScheduleMeetingModal}
                />
            )}
            {(notification && !isLoading) && (
                <NotificationMessage
                    type={notification.type}
                    title={notification.title}
                    message={notification.message}
                    onClose={() => setNotification(null)}
                />
            )}

            {/* Edit Meeting Modal (RON-5375) - reuses the 3-step NewMeetingModal in edit mode */}
            {showEditMeetingModal && selectedEvent && (
                <NewMeetingModal
                    // keyed on the edit type so "Open series" (3 -> 1) remounts a fresh modal
                    key={`edit-meeting-${editRescheduleType}`}
                    setIsLoading={setIsLoading}
                    isLoading={isLoading}
                    show={true}
                    mode="edit"
                    editMeetingId={selectedEvent.extendedProps?.meetingId}
                    rescheduleType={editRescheduleType}
                    onOpenSeries={() => setEditRescheduleType(1)}
                    date={getEventBookingDate(selectedEvent)}
                    selectedZone={selectedZoneId}
                    mapType={selectedZoneId ? (zoneMap[selectedZoneId] ?? 2) : undefined}
                    navSpotId={selectedEvent.extendedProps?.spotId}
                    setNotification={setNotification}
                    onClose={() => setShowEditMeetingModal(false)}
                    onMeetingCreated={handleEditMeetingRefresh}
                    setShowScheduleMeetingModal={setShowEditMeetingModal}
                />
            )}

            {/* RON-5375: legacy Reschedule modals - COMMENTED OUT, kept for reference.
                Their components live in the commented block near ReScheduleMeetingButton.

                {showRescheduleMeetingModal && (
                    <ReScheduleMeetingModal
                        selectedZoneId={selectedZoneId}
                        event={selectedEvent}
                        rescheduledBookingOccurrence={rescheduledBookingOccurrence}
                        setRescheduledBookingOccurrence={setRescheduledBookingOccurrence}
                        selectedRescheduleDate={selectedRescheduleDate}
                        setSelectedRescheduleDate={setSelectedRescheduleDate}
                        setShowReScheduleMeetingDateSelectModal={setShowReScheduleMeetingDateSelectModal}
                    />
                )}
                {showReScheduleMeetingDateSelectModal && (
                    <ReScheduleMeetingDateSelectModal
                        event={selectedEvent}
                        selectedRescheduleDate={selectedRescheduleDate}
                        onDateSelect={(dateStr) => {
                            setSelectedRescheduleDate(dateStr);
                            setShowReScheduleMeetingDateSelectModal(false);
                            setShowRescheduleMeetingModal(true);
                        }}
                    />
                )}
            */}
            {/* Update Existing Meeting Modal */}
            {/* {showUpdateModal && updateMeetingData && (
                <UpdateMeetingModal
                    show={showUpdateModal}
                    onClose={() => setShowUpdateModal(false)}
                    isUpdate={true}
                    bookingId={updateMeetingData.bookingId}
                    date={updateMeetingData.date}
                    startTime={updateMeetingData.startTime}
                    endTime={updateMeetingData.endTime}
                    onMeetingUpdated={() =>
                        fetchBookings(selectedZoneId, getVisibleWeekStartDateString(selectedDate))
                    }
                />
            )} */}

            {/* Start - Message Popup Modals */}
            {showAlertPopupModal && (
                <AlertPopupModal
                    title={alertPopupModalData?.title}
                    message={alertPopupModalData?.message}
                    onClose={() => setShowAlertPopupModal(false)}
                />
            )}

            {showErrorPopupModal && (
                <ErrorPopupModal
                    title={errorPopupModalData?.title}
                    message={errorPopupModalData?.message}
                    onClose={() => setShowErrorPopupModal(false)}
                />
            )}

            {/* Alert Modal */}
            {/* {(showAlertPopupModal) && (
                <AlertPopupModal
                    title={alertPopupModalData.title}
                    message={alertPopupModalData.message}
                    onClose={() => {
                        setShowAlertPopupModal(false);
                        setIsLoading(false);
                    }}
                />
            )

            } */}
            {/* End - Message Popup Modals */}
            {showPostbookingQueModal && (
                <PostbookingQueModal
                    questions={postbookingQueModalData}
                    onClose={() => setShowPostbookingQueModal(false)}
                    onSubmit={async () => {

                        setShowPostbookingQueModal(false);

                        await fetchBookings(
                            selectedZoneId,
                            getVisibleWeekStartDateString(selectedDate)
                        );

                    }}
                    postRequestParams={postRequestParams}
                    selectedBookingDate={selectedBookingDate || postRequestParams?.ClaimDate}
                />
            )}
            {showAddVehiclePopup && (
                <NoVehiclePopUp
                    onClose={handleAddVehiclePopupClose}
                    onConfirm={handleAddVehiclePopupConfirm}
                    variant="orange"
                />
            )}
            {renderApiUi(isLoading)}

        </div>
    );
}

export default WeeklyCalendarEvent;

// ----------------------------------------------------- Reausable Hooks ----------------------------------------------------- 

export const useBookingContext = (clickedFullDay, weekData) => {
    const bookingDateStr = useMemo(
        () => getBookingDateStr(clickedFullDay),
        [clickedFullDay]
    );

    const weekKey = useMemo(
        () => getWeekKey(clickedFullDay),
        [clickedFullDay]
    );

    const bookingForModal = useMemo(() => {
        if (!bookingDateStr) return null;

        if (weekKey && weekData?.[weekKey]) {
            return (
                weekData[weekKey].find(
                    b => b.BookingDate === bookingDateStr
                ) || null
            );
        }

        return (
            weekData?.find(
                b => b.BookingDate === bookingDateStr
            ) || null
        );
    }, [weekKey, weekData, bookingDateStr]);

    return { bookingDateStr, weekKey, bookingForModal };
};

export const useBookingDisplayDate = (clickedFullDay, setSelectedDay) => {
    // parseLocalDate, not new Date(): "YYYY-MM-DD" as UTC midnight is the previous day in UTC− zones.
    const bookingDate = clickedFullDay ? parseLocalDate(clickedFullDay) : null;

    const displayMonth = bookingDate
        ? bookingDate.toLocaleDateString("en-US", { month: "long" })
        : "";

    const displayYear = bookingDate
        ? bookingDate.getFullYear()
        : "";

    useEffect(() => {
        if (!bookingDate) return;
        setSelectedDay(bookingDate.getDate());
    }, [bookingDate, setSelectedDay]);

    return { bookingDate, displayMonth, displayYear };
};
